/* eslint-disable max-len,react/jsx-tag-spacing */

import React from 'react';

import { COMPONENT_TYPE as TYPE } from 'common/constants';
import EditIcon from 'common/components/Icon/Edit';
import PhoneIcon from 'common/components/Icon/Phone';
import CheckMarkIcon from 'common/components/Icon/CheckMark';
import Publish from 'admin/components/common/Icon/Publish';
import { PROP_FIELD_ICONS } from 'admin/components/pages/Story/CardEditor/Inspector/config/prop-fields-config';
import css from './Icon.scss';

const LAYER_ICONS = {
	[TYPE.BOX]: 'sc-layer-box',
	[TYPE.CARD]: 'sc-layer-box',
	[TYPE.SWIPE]: 'sc-layer-box',
	[TYPE.TEXT]: 'sc-layer-text',
	[TYPE.RESULT_TEXT]: 'sc-layer-text',
	[TYPE.SHAPE]: 'sc-layer-shape',
	[TYPE.RESULT_SHAPE]: 'sc-layer-shape',
	[TYPE.IMG]: 'sc-layer-img',
	[TYPE.BUTTON]: 'sc-layer-btn',
	[TYPE.BUTTON_SUBMIT]: 'sc-layer-btn',
	[TYPE.SMS_LOGIN]: 'sc-layer-btn',
	[TYPE.GOOGLE_LOGIN]: 'sc-layer-btn',
	[TYPE.ANSWER]: 'sc-layer-answer',
	[TYPE.TEXT_FIELD]: 'sc-layer-tf',
	[TYPE.TEXT_AREA_FIELD]: 'sc-layer-ta',
	[TYPE.CHECKBOX]: 'sc-layer-checkbox',
	[TYPE.VIDEO]: 'sc-layer-video',
	[TYPE.TIMER]: 'sc-layer-timer',
	[TYPE.EMBED]: 'sc-layer-embed',
	[TYPE.SHARE]: 'sc-share-share',
	SYMBOL: 'sc-layer-symbol',
	LOCKED: 'sc-layer-lock',
	UNLOCKED: 'sc-layer-unlock',
	HIDDEN: 'sc-layer-hide',
	VISIBLE: 'sc-layer-show',
};

type Props = {
	type: string;
	className?: string;
	width?: number;
	height?: number;
	viewBox?: string;
	color?: string;
};

/**
 * @link - https://material.io/tools/icons/?style=baseline
 * @link - https://sketch.com/s/3e6b322c-7d4f-47d9-9d35-f1596c28182f
 *
 * @description Main icon component. To preview all icons need to uncomment `IconsPreview` in the end of this file and
 * also uncomment route that renders this component in `App.tsx`
 */
const Icon: React.FC<Props> = ({
	type,
	className = '',
	width = undefined,
	height = undefined,
	viewBox = '0 0 24 24',
	color = '#FFF',
	...iconProps
}) => {
	let icon;
	const svgProps = {
		width,
		height,
		viewBox,
		xmlns: 'http://www.w3.org/2000/svg',
		className: css.svg,
	};

	switch (type) {
		case 'sc-circle-check':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.2" transform="translate(3.000000, 3.000000)" fill={color}>
							<path d="M9,0 C4.032,0 0,4.032 0,9 C0,13.968 4.032,18 9,18 C13.968,18 18,13.968 18,9 C18,4.032 13.968,0 9,0 Z" />
						</g>
						<path
							d="M12,3 C7.032,3 3,7.032 3,12 C3,16.968 7.032,21 12,21 C16.968,21 21,16.968 21,12 C21,7.032 16.968,3 12,3 Z M12,3.9 C7.5288,3.9 3.9,7.5288 3.9,12 C3.9,16.4712 7.5288,20.1 12,20.1 C16.4712,20.1 20.1,16.4712 20.1,12 C20.1,7.5288 16.4712,3.9 12,3.9 Z M11.0868855,12.3080777 L8.50704487,12.9688513 C8.74486368,13.8340342 9.30315958,14.6171333 10.1531399,15.1078697 C11.3737039,15.8125627 12.8330319,15.7234664 13.911679,14.9992391 L15.0131867,15.6344968 C13.5534604,16.8949872 11.3744687,17.1485603 9.57482716,16.1095368 C8.51866685,15.4997623 7.78733406,14.5539892 7.43176304,13.491649 L7.36133927,13.2623005 L5.47853635,13.7445422 L7.50263101,10.2387074 L11.0868855,12.3080777 Z M18.2749764,10.4804578 L16.2508818,13.9862926 L12.6875458,11.9289996 L15.2577639,11.2626704 C15.0231725,10.3993509 14.4692993,9.61880524 13.6242796,9.1309329 C12.3544778,8.39781247 10.8221647,8.5333253 9.73452369,9.35413401 L8.65855367,8.73287582 C10.113683,7.37158226 12.3601375,7.06552398 14.2025924,8.12926582 C15.2525888,8.73548149 15.9783303,9.67802655 16.3296602,10.7379181 L16.3991961,10.966754 L18.2749764,10.4804578 Z"
							opacity="0.8"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sync-progress':
			icon = (
				<svg {...svgProps}>
					<path d="M11.2944216,4.25 C13.5278564,4.25 15.4235523,5.75914286 15.939622,7.88771429 C16.3587852,7.77114286 16.7859762,7.71114286 17.214314,7.71114286 C19.8525768,7.71114286 21.9994266,10.6028571 22,13.2297143 C22,15.8605714 19.8531502,18 17.214314,18 L17.214314,18 L6.53453915,18 C3.89570296,18 1.75,15.8605714 1.75,13.2297143 C1.75,10.6028571 3.89570296,7.71114286 6.53453915,7.71057143 C6.58671952,7.71057143 6.64062013,7.714 6.69509415,7.71514286 C7.27137194,5.69171429 9.16248053,4.25 11.2944216,4.25 Z M16.2211538,11.25 C15.4120192,11.25 14.75,11.925 14.75,12.75 C14.75,13.575 15.4120192,14.25 16.2211538,14.25 C17.0302885,14.25 17.6923077,13.575 17.6923077,12.75 C17.6923077,11.925 17.0302885,11.25 16.2211538,11.25 Z M7.22115385,11.25 C6.41201923,11.25 5.75,11.925 5.75,12.75 C5.75,13.575 6.41201923,14.25 7.22115385,14.25 C8.03028846,14.25 8.69230769,13.575 8.69230769,12.75 C8.69230769,11.925 8.03028846,11.25 7.22115385,11.25 Z M11.8076923,11.25 C10.9985577,11.25 10.3365385,11.925 10.3365385,12.75 C10.3365385,13.575 10.9985577,14.25 11.8076923,14.25 C12.6168269,14.25 13.2788462,13.575 13.2788462,12.75 C13.2788462,11.925 12.6168269,11.25 11.8076923,11.25 Z" />
				</svg>
			);
			break;
		case 'sync-updated':
			icon = (
				<svg {...svgProps}>
					<path d="M11.2944216,4.25 C13.5278564,4.25 15.4235523,5.75914286 15.939622,7.88771429 C16.3587852,7.77114286 16.7859762,7.71114286 17.214314,7.71114286 C19.8525768,7.71114286 21.9994266,10.6028571 22,13.2297143 C22,15.8605714 19.8531502,18 17.214314,18 L17.214314,18 L6.53453915,18 C3.89570296,18 1.75,15.8605714 1.75,13.2297143 C1.75,10.6028571 3.89570296,7.71114286 6.53453915,7.71057143 C6.58671952,7.71057143 6.64062013,7.714 6.69509415,7.71514286 C7.27137194,5.69171429 9.16248053,4.25 11.2944216,4.25 Z M15,8.5 L10.5,13.5 L8,11.5 L6.5,13 L10.5,16.5 L16.5,10 L15,8.5 Z" />
				</svg>
			);
			break;
		case 'arrow':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<polygon fill={color} points="16.01 11 4 11 4 13 16.01 13 16.01 16 20 12 16.01 8" />
					</g>
				</svg>
			);
			break;
		case 'sc-arrow-thin':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<polygon
							fill={color}
							points="6.48366047 9.5 6.48366047 11.457657 19.7771247 11.457657 19.7771247 12.457657 6.48366047 12.457657 6.48366047 14.5 3.75 12.1419769"
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-arrow-updown':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M7.365 13.795l4.59 4.58 3.04-3.033 1.55-1.547 1.41 1.41L16.36 16.8l-4.405 4.405-6-6 1.41-1.41zm0-2.84l4.59-4.58 4.59 4.58 1.41-1.41-6-6-6 6 1.41 1.41z"
						/>
					</g>
				</svg>
			);
			break;
		case 'close':
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
					/>
				</svg>
			);
			break;
		case 'drag-handle':
			icon = (
				<svg {...svgProps}>
					<path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" fill={color} />
				</svg>
			);
			break;
		case 'keyboard-return':
			icon = (
				<svg {...svgProps}>
					<path fill={color} d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z" />
				</svg>
			);
			break;
		case 'more':
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
					/>
				</svg>
			);
			break;
		case 'search':
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
					/>
				</svg>
			);
			break;
		case 'tune':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.25" transform="translate(3.000000, 7.207000)" fill={color}>
							<path d="M4,0.793 C5.00659729,0.793 5.92635245,1.16481534 6.62941704,1.77859758 C5.64101913,2.50635025 5,3.6783161 5,5 C5,6.20254171 5.53065968,7.28114121 6.37058296,8.01440242 C5.70740897,8.50399286 4.8874551,8.793 4,8.793 C1.790861,8.793 2.705415e-16,7.002139 0,4.793 C-2.705415e-16,2.583861 1.790861,0.793 4,0.793 Z" />
						</g>
						<g opacity="0.5" transform="translate(8.000000, 8.207000)" fill={color}>
							<path d="M4,0 C4.94650821,-1.73870737e-16 5.81623295,0.328749092 6.50121926,0.878292307 C5.58544795,1.61054734 5,2.73690432 5,4 C5,5.26309568 5.58544795,6.38945266 6.49979019,7.12251727 C5.81623295,7.67125091 4.94650821,8 4,8 C1.790861,8 2.705415e-16,6.209139 0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z" />
						</g>
						<path
							d="M17,8.207 C19.209139,8.207 21,9.997861 21,12.207 C21,14.416139 19.209139,16.207 17,16.207 C14.790861,16.207 13,14.416139 13,12.207 C13,9.997861 14.790861,8.207 17,8.207 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'swap-horizontal':
			icon = (
				<svg {...svgProps}>
					<path fill={color} d="M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z" />
				</svg>
			);
			break;
		case 'undo':
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
					/>
				</svg>
			);
			break;
		case 'redo':
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
					/>
				</svg>
			);
			break;
		case 'done-all':
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
					/>
				</svg>
			);
			break;
		case 'edit':
			icon = <EditIcon {...svgProps} color={color} />;
			break;
		case 'edit-empty':
			icon = <EditIcon {...svgProps} color={color} empty />;
			break;
		case 'info':
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
					/>
				</svg>
			);
			break;
		case 'chevron-left':
			icon = (
				<svg {...svgProps}>
					<path fill={color} d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
				</svg>
			);
			break;
		case 'chevron-right':
			icon = (
				<svg {...svgProps}>
					<path fill={color} d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
				</svg>
			);
			break;
		case 'chevron-up':
			icon = (
				<svg {...svgProps}>
					<path fill={color} d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
				</svg>
			);
			break;
		case 'chevron-down':
			icon = (
				<svg {...svgProps}>
					<path fill={color} d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
				</svg>
			);
			break;
		case 'remove':
			icon = (
				<svg {...svgProps}>
					<path d="M19 13H5v-2h14v2z" fill={color} />
				</svg>
			);
			break;
		case 'remove-circle':
			icon = (
				<svg {...svgProps}>
					<path d="M0 0h24v24H0z" fill="none" />
					<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z" />
				</svg>
			);
			break;
		case 'sync-problem':
			icon = (
				<svg {...svgProps}>
					<path d="M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z" />
				</svg>
			);
			break;
		case 'sync-disabled':
			icon = (
				<svg {...svgProps}>
					<path d="M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z" />
				</svg>
			);
			break;

		// custom icons
		case 'sc-dropdown':
			icon = (
				<svg {...svgProps}>
					<path fill={color} d="M7 10l5 5 5-5z" />
				</svg>
			);
			break;
		case 'sc-menu':
			icon = (
				<svg {...svgProps}>
					<path fill={color} d="M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z" />
				</svg>
			);
			break;
		case 'sc-alert':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M13.0289915,4.17231541 C13.3104907,4.34121494 13.5460863,4.57681054 13.7149859,4.85830975 L22.1826051,18.9710085 C22.7509014,19.918169 22.4437713,21.1466895 21.4966108,21.7149859 C21.1857799,21.9014843 20.8301071,22 20.4676192,22 L3.53238076,22 C2.42781126,22 1.53238076,21.1045695 1.53238076,20 C1.53238076,19.6375121 1.63089642,19.2818393 1.81739491,18.9710085 L10.2850141,4.85830975 C10.8533105,3.91114922 12.081831,3.60401909 13.0289915,4.17231541 Z M11.9486631,17.1377005 C11.5609626,17.1377005 11.2292447,17.2730615 10.9535094,17.5437834 C10.6777741,17.8145053 10.5415775,18.1403743 10.5449198,18.5213904 C10.5415775,18.9124332 10.6777741,19.2441511 10.9535094,19.5165441 C11.2292447,19.7889372 11.5609626,19.9251337 11.9486631,19.9251337 C12.1959893,19.9251337 12.4249332,19.8624666 12.6354947,19.7371324 C12.8460561,19.6117981 13.0173463,19.4430147 13.149365,19.2307821 C13.2813837,19.0185495 13.3490642,18.7820856 13.3524064,18.5213904 C13.3490642,18.1403743 13.2061832,17.8145053 12.9237634,17.5437834 C12.6413436,17.2730615 12.3163102,17.1377005 11.9486631,17.1377005 Z M13.3524064,9.4973262 L10.5449198,9.4973262 L10.805615,16.5561497 L13.0917112,16.5561497 L13.3524064,9.4973262 Z"
							fillOpacity="0.95"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-option-key':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M9.338,3.99906632 L15.337,18.9990663 L20,19 L20,20 L14.661,19.9990663 L8.661,4.99906632 L4,5 L4,4 L9.338,3.99906632 Z M20,4 L20,5 L15,5 L15,4 L20,4 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-override':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M6.58578199,3.25 L7.912,4.832 L8.0310901,4.7650114 C9.19468252,4.13734299 10.5259373,3.78103478 11.9399066,3.78103478 C16.4939066,3.78103478 20.1899066,7.47703478 20.1899066,12.0310348 C20.1899066,16.5850348 16.4939066,20.2810348 11.9399066,20.2810348 C7.72440048,20.2810348 4.24408624,17.1140546 3.75,13.0311303 L4.50611192,13.0311205 C4.99556441,16.6987084 8.13918423,19.5310348 11.9399066,19.5310348 C16.079693,19.5310348 19.4399066,16.1708212 19.4399066,12.0310348 C19.4399066,7.89124834 16.079693,4.53103478 11.9399066,4.53103478 C10.6616659,4.53103478 9.4577488,4.85139327 8.4041233,5.4161421 L9.79972004,7.08022222 L6.18990657,7.03103478 L6.58578199,3.25 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-plus':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<polygon
							fill={color}
							points="24 13.5714286 13.7142857 13.5714286 13.7142857 23 10.2857143 23 10.2857143 13.5714286 0 13.5714286 0 10.4285714 10.2857143 10.4285714 10.2857143 1 13.7142857 1 13.7142857 10.4285714 24 10.4285714"
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-full-hd':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fillRule="evenodd" fill={color}>
						<g opacity="0.505650112" transform="translate(2.750000, 6.250000)">
							<polygon className="path fill" points="18.5 0 5.25801624e-13 0 5.25801624e-13 10 18.5 10" />
						</g>
						<path d="M20.786121,5.25 L20.9090805,5.25306412 C21.1384413,5.26223165 21.272448,5.28955564 21.383011,5.33360711 L21.4366718,5.35702018 C21.4541295,5.36528478 21.4712689,5.37400742 21.4884229,5.38318148 C21.6513858,5.47033502 21.7792801,5.59822931 21.8664336,5.76119227 C21.9320924,5.88396351 21.9746282,6.00598564 21.9916157,6.24930706 L22,6.24961512 L22,16.2496151 L21.9915984,16.2501695 C21.9745995,16.493327 21.9320703,16.6153082 21.8664336,16.738038 C21.7792801,16.9010009 21.6513858,17.0288952 21.4884229,17.1160488 C21.4712689,17.1252228 21.4541295,17.1339455 21.4366718,17.1422101 L21.383011,17.1656231 C21.272448,17.2096746 21.1384413,17.2369986 20.9090805,17.2461661 L20.786121,17.2492302 L20.7180574,17.2496151 L14,17.2496151 L14,18.4996151 L14.25,18.4996151 C14.6494202,18.4996151 14.9759152,18.8118451 14.9987268,19.2055469 L15,19.2496151 L9,19.2496151 C9,18.8354016 9.33578644,18.4996151 9.75,18.4996151 L10,18.4996151 L10,17.2496151 L3.2819426,17.2496151 L3.213879,17.2492302 L3.09091952,17.2461661 C2.86155873,17.2369986 2.72755202,17.2096746 2.61698898,17.1656231 L2.56332818,17.1422101 C2.55459935,17.1380778 2.54595009,17.133831 2.53733879,17.1294705 L2.51157715,17.1160488 C2.34861419,17.0288952 2.2207199,16.9010009 2.13356635,16.738038 C2.06792974,16.6153082 2.02540053,16.493327 2.00840156,16.2501695 L2,16.2496151 L2,6.24961512 L2.00838435,6.24930706 C2.02537181,6.00598564 2.06790758,5.88396351 2.13356635,5.76119227 C2.2207199,5.59822931 2.34861419,5.47033502 2.51157715,5.38318148 C2.52873114,5.37400742 2.54587052,5.36528478 2.56332818,5.35702018 L2.61698898,5.33360711 C2.72755202,5.28955564 2.86155873,5.26223165 3.09091952,5.25306412 L3.213879,5.25 L20.786121,5.25 Z M21,6.24961512 L3,6.24961512 L3,16.2496151 L21,16.2496151 L21,6.24961512 Z" />
					</g>
				</svg>
			);
			break;
		case 'sc-computer':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.505650112" transform="translate(4.000000, 7.000000)" fill="#000000">
							<polygon className="path fill" points="16 0 1.80300219e-13 0 1.80300219e-13 10 16 10" />
						</g>
						<path
							d="M20,7 L4,7 L4,17 L3,17 L3,7.2819426 C3,6.83618323 3.04641281,6.67454011 3.13356635,6.51157715 C3.2207199,6.34861419 3.34861419,6.2207199 3.51157715,6.13356635 C3.67454011,6.04641281 3.83618323,6 4.2819426,6 L19.7180574,6 C20.1638168,6 20.3254599,6.04641281 20.4884229,6.13356635 C20.6513858,6.2207199 20.7792801,6.34861419 20.8664336,6.51157715 C20.9535872,6.67454011 21,6.83618323 21,7.2819426 L21,17 L24,17 C24,18.1045695 22.1045695,19 21,19 L3,19 C1.8954305,19 0,18.1045695 0,17 L20,17 L20,7 Z"
							fill="#000000"
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-computer-default':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<polygon points="0 0 24.0417391 0 24.0417391 24.0417391 0 24.0417391" />
						<g opacity="0.505650112" transform="translate(4.006957, 7.012174)" fill="#27C49D">
							<polygon points="16.0278261 0 4.55538216e-13 0 4.55538216e-13 10.0173913 16.0278261 10.0173913" />
						</g>
						<path
							d="M20.0347826,7.01217391 L4.00695652,7.01217391 L4.00695652,17.0295652 L3.00521739,17.0295652 L3.00521739,7.29460685 C3.00521739,6.84807224 3.05171091,6.68614801 3.13901603,6.52290163 C3.22632115,6.35965525 3.35443786,6.23153854 3.51768424,6.14423342 C3.68093062,6.05692831 3.84285485,6.01043478 4.28938946,6.01043478 L19.7523497,6.01043478 C20.1988843,6.01043478 20.3608085,6.05692831 20.5240549,6.14423342 C20.6873013,6.23153854 20.815418,6.35965525 20.9027231,6.52290163 C20.9900282,6.68614801 21.0365217,6.84807224 21.0365217,7.29460685 L21.0365217,17.0295652 L24.0417391,17.0295652 C24.0417391,18.1360557 22.1430122,19.0330435 21.0365217,19.0330435 L3.00521739,19.0330435 C1.8987269,19.0330435 0,18.1360557 0,17.0295652 L20.0347826,17.0295652 L20.0347826,7.01217391 Z"
							style={{ fill: '#27C49D' }}
						/>
						<polygon
							fill="#27C49D"
							points="12 13.6 9.64885899 15.236068 10.4783096 12.4944272 8.19577393 10.763932 11.0595436 10.7055728 12 8 12.9404564 10.7055728 15.8042261 10.763932 13.5216904 12.4944272 14.351141 15.236068"
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-tablet':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(6.000000, 3.000000)" fill="#000000" fillOpacity="0.87">
							<path
								className="fill"
								d="M10.7180574,0 L1.2819426,0 C0.83618323,0 0.674540111,0.0464128056 0.511577148,0.133566352 C0.348614185,0.220719898 0.220719898,0.348614185 0.133566352,0.511577148 C0.0573069989,0.654169741 0.0122397755,0.795751828 0.00216452201,1.12754329 L0,1.2819426 L0,16.7180574 C0,17.1638168 0.0464128056,17.3254599 0.133566352,17.4884229 C0.220719898,17.6513858 0.348614185,17.7792801 0.511577148,17.8664336 C0.654169741,17.942693 0.795751828,17.9877602 1.12754329,17.9978355 L1.2819426,18 L10.7180574,18 C11.1638168,18 11.3254599,17.9535872 11.4884229,17.8664336 C11.6513858,17.7792801 11.7792801,17.6513858 11.8664336,17.4884229 C11.942693,17.3458303 11.9877602,17.2042482 11.9978355,16.8724567 L12,16.7180574 L12,1.2819426 C12,0.83618323 11.9535872,0.674540111 11.8664336,0.511577148 C11.7792801,0.348614185 11.6513858,0.220719898 11.4884229,0.133566352 C11.3458303,0.0573069989 11.2042482,0.0122397755 10.8724567,0.00216452201 L10.7180574,0 Z"
							/>
						</g>
						<path
							d="M16.4361148,2 C17.3276335,2 17.6509198,2.09282561 17.9768457,2.2671327 C18.3027716,2.4414398 18.5585602,2.69722837 18.7328673,3.0231543 C18.9071744,3.34908022 19,3.67236646 19,4.5638852 L19,19.4361148 C19,20.3276335 18.9071744,20.6509198 18.7328673,20.9768457 C18.5585602,21.3027716 18.3027716,21.5585602 17.9768457,21.7328673 C17.6509198,21.9071744 17.3276335,22 16.4361148,22 L7.5638852,22 C6.67236646,22 6.34908022,21.9071744 6.0231543,21.7328673 C5.69722837,21.5585602 5.4414398,21.3027716 5.2671327,20.9768457 C5.10623385,20.675991 5.014763,20.3773855 5.00164263,19.6320228 L5,4.5638852 C5,3.67236646 5.09282561,3.34908022 5.2671327,3.0231543 C5.4414398,2.69722837 5.69722837,2.4414398 6.0231543,2.2671327 C6.34908022,2.09282561 6.67236646,2 7.5638852,2 L16.4361148,2 Z M16.7180574,3 L7.2819426,3 C6.83618323,3 6.67454011,3.04641281 6.51157715,3.13356635 C6.34861419,3.2207199 6.2207199,3.34861419 6.13356635,3.51157715 C6.057307,3.65416974 6.01223978,3.79575183 6.00216452,4.12754329 L6,4.2819426 L6,19.7180574 C6,20.1638168 6.04641281,20.3254599 6.13356635,20.4884229 C6.2207199,20.6513858 6.34861419,20.7792801 6.51157715,20.8664336 C6.65416974,20.942693 6.79575183,20.9877602 7.12754329,20.9978355 L7.2819426,21 L16.7180574,21 C17.1638168,21 17.3254599,20.9535872 17.4884229,20.8664336 C17.6513858,20.7792801 17.7792801,20.6513858 17.8664336,20.4884229 C17.942693,20.3458303 17.9877602,20.2042482 17.9978355,19.8724567 L18,19.7180574 L18,4.2819426 C18,3.83618323 17.9535872,3.67454011 17.8664336,3.51157715 C17.7792801,3.34861419 17.6513858,3.2207199 17.4884229,3.13356635 C17.3458303,3.057307 17.2042482,3.01223978 16.8724567,3.00216452 L16.7180574,3 Z"
							fillOpacity="0.87"
							fill="#000000"
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-phone-iphone':
			icon = <PhoneIcon {...svgProps} />;
			break;
		case 'sc-full-hd-no-paddings':
			icon = (
				<svg {...{ ...svgProps, viewBox: `0 0 ${width} ${height}` }}>
					<g stroke="none" strokeWidth="1" fill="#000" fillRule="evenodd">
						<g opacity="0.505650112" transform="translate(7.000000, 10.000000)" fill={color}>
							<polygon points="95 0 2.7000624e-12 0 2.7000624e-12 52 95 52" />
						</g>
						<path d="M99.7485231,3 L100.381764,3.01575874 C101.562973,3.06290737 102.253107,3.2034346 102.822507,3.42999123 L103.09886,3.55040464 C103.188767,3.59290947 103.277035,3.63776998 103.365378,3.68495214 C104.204637,4.1331827 104.863293,4.79094283 105.312133,5.62906111 C105.650276,6.26047338 105.869335,6.88803305 105.956821,8.13943473 L106,8.14101912 L106,59.5710044 L105.956732,59.5738556 C105.869187,60.8244141 105.650162,61.4517632 105.312133,62.0829624 C104.863293,62.9210807 104.204637,63.5788408 103.365378,64.0270714 C103.277035,64.0742536 103.188767,64.1191141 103.09886,64.1616189 L102.822507,64.2820323 C102.253107,64.5085889 101.562973,64.6491162 100.381764,64.6962648 L99.7485231,64.7120235 L99.3979956,64.7140029 L64.8,64.7140029 L64.8,71.1427511 L66.0875,71.1427511 C68.1445141,71.1427511 69.8259634,72.7485495 69.9434432,74.7733573 L69.95,75 L39.05,75 C39.05,72.8697003 40.7793002,71.1427511 42.9125,71.1427511 L44.2,71.1427511 L44.2,64.7140029 L9.60200439,64.7140029 L9.25147687,64.7120235 L8.61823551,64.6962648 C7.43702744,64.6491162 6.74689291,64.5085889 6.17749326,64.2820323 L5.90114014,64.1616189 C5.85618665,64.1403665 5.81164296,64.1185251 5.76729476,64.0960991 L5.63462231,64.0270714 C4.79536305,63.5788408 4.13670748,62.9210807 3.68786671,62.0829624 C3.34983815,61.4517632 3.13081271,60.8244141 3.04326801,59.5738556 L3,59.5710044 L3,8.14101912 L3.04317939,8.13943473 C3.13066483,6.88803305 3.34972403,6.26047338 3.68786671,5.62906111 C4.13670748,4.79094283 4.79536305,4.1331827 5.63462231,3.68495214 C5.72296539,3.63776998 5.81123316,3.59290947 5.90114014,3.55040464 L6.17749326,3.42999123 C6.74689291,3.2034346 7.43702744,3.06290737 8.61823551,3.01575874 L9.25147687,3 L99.7485231,3 Z M100.690722,8.29411765 L8.30927835,8.29411765 L8.30927835,60.1764706 L100.690722,60.1764706 L100.690722,8.29411765 Z" />
					</g>
				</svg>
			);
			break;
		case 'sc-computer-no-paddings':
			icon = (
				<svg {...{ ...svgProps, viewBox: `0 0 ${width} ${height}` }}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.87">
						<g fill="#000000">
							<path d="M86.8722296,2.07168062e-16 C88.6552671,-1.2037061e-16 89.3018396,0.185651222 89.9536914,0.534265408 C90.6055433,0.882879593 91.1171204,1.39445674 91.4657346,2.04630859 C91.8143488,2.69816044 92,3.34473292 92,5.1277704 L92,47.999 L104,48 L104,50 C100.087697,52.6082017 95.4909,54 90.7888974,54 L13.2111026,54 C8.67702868,54 4.24077946,52.7058406 0.421768129,50.2747876 L0,50 L0,48 L12,47.999 L12,5.1277704 C12,3.34473292 12.1856512,2.69816044 12.5342654,2.04630859 C12.8828796,1.39445674 13.3944567,0.882879593 14.0463086,0.534265408 C14.6981604,0.185651222 15.3447329,1.2037061e-16 17.1277704,-2.07168062e-16 L86.8722296,2.07168062e-16 Z M88,3 L16,3 C15.4477153,3 15,3.44771525 15,4 L15,4 L15,47.999 L89,47.999 L89,4 C89,3.48716416 88.6139598,3.06449284 88.1166211,3.00672773 L88,3 Z" />
						</g>
					</g>
				</svg>
			);
			break;
		case 'sc-tablet-no-paddings':
			icon = (
				<svg {...{ ...svgProps, viewBox: `0 0 ${width} ${height}` }}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g fill="#202020">
							<path d="M52.3083444,3.10752092e-16 C54.9829006,-1.80555915e-16 55.9527593,0.278476833 56.9305371,0.801398111 C57.9083149,1.32431939 58.6756806,2.09168511 59.1986019,3.06946289 C59.7215232,4.04724067 60,5.01709938 60,7.6916556 L60,78.3083444 C60,80.9829006 59.7215232,81.9527593 59.1986019,82.9305371 C58.6756806,83.9083149 57.9083149,84.6756806 56.9305371,85.1986019 C55.9527593,85.7215232 54.9829006,86 52.3083444,86 L7.6916556,86 C5.01709938,86 4.04724067,85.7215232 3.06946289,85.1986019 C2.09168511,84.6756806 1.32431939,83.9083149 0.801398111,82.9305371 C0.278476833,81.9527593 1.2037061e-16,80.9829006 -2.07168062e-16,78.3083444 L2.07168062e-16,7.6916556 C-1.2037061e-16,5.01709938 0.278476833,4.04724067 0.801398111,3.06946289 C1.32431939,2.09168511 2.09168511,1.32431939 3.06946289,0.801398111 C4.04724067,0.278476833 5.01709938,1.80555915e-16 7.6916556,-3.10752092e-16 L52.3083444,3.10752092e-16 Z M53.1541722,3 L6.8458278,3 C5.50854969,3 5.02362033,3.13923842 4.53473144,3.40069906 C4.04584256,3.66215969 3.66215969,4.04584256 3.40069906,4.53473144 C3.13923842,5.02362033 3,5.50854969 3,6.8458278 L3,6.8458278 L3,79.1541722 C3,80.4914503 3.13923842,80.9763797 3.40069906,81.4652686 C3.66215969,81.9541574 4.04584256,82.3378403 4.53473144,82.5993009 C5.02362033,82.8607616 5.50854969,83 6.8458278,83 L6.8458278,83 L53.1541722,83 C54.4914503,83 54.9763797,82.8607616 55.4652686,82.5993009 C55.9541574,82.3378403 56.3378403,81.9541574 56.5993009,81.4652686 C56.8607616,80.9763797 57,80.4914503 57,79.1541722 L57,79.1541722 L57,6.8458278 C57,5.50854969 56.8607616,5.02362033 56.5993009,4.53473144 C56.3378403,4.04584256 55.9541574,3.66215969 55.4652686,3.40069906 C54.9763797,3.13923842 54.4914503,3 53.1541722,3 L53.1541722,3 Z" />
						</g>
					</g>
				</svg>
			);
			break;
		case 'sc-phone-iphone-no-paddings':
			icon = (
				<svg {...{ ...svgProps, viewBox: `0 0 ${width} ${height}` }}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g fill="#202020">
							<path d="M29.7068272,1.93698042e-15 C31.8951005,-1.1254414e-15 32.6886213,0.227844682 33.4886213,0.655689364 C34.2886213,1.08353405 34.916466,1.71137873 35.3443106,2.51137873 C35.7721553,3.31137873 36,4.10489949 36,6.29317276 L36,65.7068272 C36,67.8951005 35.7721553,68.6886213 35.3443106,69.4886213 C34.916466,70.2886213 34.2886213,70.916466 33.4886213,71.3443106 C32.6886213,71.7721553 31.8951005,72 29.7068272,72 L6.29317276,72 C4.10489949,72 3.31137873,71.7721553 2.51137873,71.3443106 C1.71137873,70.916466 1.08353405,70.2886213 0.655689364,69.4886213 C0.227844682,68.6886213 -1.64963331e-16,67.8951005 2.83915928e-16,65.7068272 L6.22918211e-16,6.29317276 C-3.61933419e-16,4.10489949 0.227844682,3.31137873 0.655689364,2.51137873 C1.08353405,1.71137873 1.71137873,1.08353405 2.51137873,0.655689364 C3.31137873,0.227844682 4.10489949,1.47727567e-16 6.29317276,-2.54251712e-16 L29.7068272,1.93698042e-15 Z M29.8045515,2 L6.19544851,2 C4.73659966,2 4.20758582,2.15189645 3.67425249,2.43712624 C3.14091915,2.72235603 2.72235603,3.14091915 2.43712624,3.67425249 C2.15189645,4.20758582 2,4.73659966 2,6.19544851 L2,6.19544851 L2,65.8045515 C2,67.2634003 2.15189645,67.7924142 2.43712624,68.3257475 C2.72235603,68.8590808 3.14091915,69.277644 3.67425249,69.5628738 C4.20758582,69.8481035 4.73659966,70 6.19544851,70 L6.19544851,70 L29.8045515,70 C31.2634003,70 31.7924142,69.8481035 32.3257475,69.5628738 C32.8590808,69.277644 33.277644,68.8590808 33.5628738,68.3257475 C33.8481035,67.7924142 34,67.2634003 34,65.8045515 L34,65.8045515 L34,6.19544851 C34,4.73659966 33.8481035,4.20758582 33.5628738,3.67425249 C33.277644,3.14091915 32.8590808,2.72235603 32.3257475,2.43712624 C31.7924142,2.15189645 31.2634003,2 29.8045515,2 L29.8045515,2 Z M26,2 C25.4477153,2 25,2.44771525 25,3 L25,3.5 C25,4.32842712 24.3284271,5 23.5,5 L12.5,5 C11.6715729,5 11,4.32842712 11,3.5 L11,3 C11,2.44771525 10.5522847,2 10,2 L26,2 Z" />
						</g>
					</g>
				</svg>
			);
			break;
		case 'sc-layers':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(4.236000, 5.059034)" fill={color}>
							<path d="M11.645,8 L15.527,9.94096601 L7.764,13.822932 L1.15463195e-13,9.94096601 L3.882,8 L7.3167864,9.71735921 C7.55809568,9.83801385 7.83602557,9.85525023 8.08779788,9.76906834 L8.2112136,9.71735921 L11.645,8 Z M7.764,0.059 L15.527,3.93996601 L7.764,7.82293202 L5.69322367e-13,3.94096601 L7.764,0.059 Z" />
						</g>
						<path
							d="M16.9999245,12.500034 L21.1055728,14.5527864 C21.3525621,14.676281 21.4526742,14.9766175 21.3291796,15.2236068 C21.2807978,15.3203705 21.2023365,15.3988317 21.1055728,15.4472136 L12.4472136,19.7763932 C12.1656861,19.9171569 11.8343139,19.9171569 11.5527864,19.7763932 L2.89442719,15.4472136 C2.64743794,15.323719 2.54732577,15.0233825 2.67082039,14.7763932 C2.71920224,14.6796295 2.79766349,14.6011683 2.89442719,14.5527864 L6.99892446,12.500034 L8.11692446,13.059034 L4.236,15 L12,18.881966 L19.763,15 L15.8819245,13.059034 L16.9999245,12.500034 Z M12.4472136,4.2236068 L21.1055728,8.5527864 C21.3525621,8.67628103 21.4526742,8.97661755 21.3291796,9.2236068 C21.2807978,9.3203705 21.2023365,9.39883174 21.1055728,9.4472136 L12.4472136,13.7763932 C12.1656861,13.9171569 11.8343139,13.9171569 11.5527864,13.7763932 L2.89442719,9.4472136 C2.64743794,9.32371897 2.54732577,9.02338245 2.67082039,8.7763932 C2.71920224,8.6796295 2.79766349,8.60116826 2.89442719,8.5527864 L11.5527864,4.2236068 C11.8343139,4.08284305 12.1656861,4.08284305 12.4472136,4.2236068 Z M12,5.11803399 L4.236,9 L12,12.881966 L19.763,8.999 L12,5.11803399 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-add-stroke':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(6.000000, 6.000000)" fill={color}>
							<path d="M7,0 L7,5 L12,5 L12,7 L7,7 L7,12 L5,12 L5,7 L0,7 L0,5 L5,5 L5,0 L7,0 Z" />
						</g>
						<path
							d="M14,5 L14,10 L19,10 L19,14 L14,14 L14,19 L10,19 L10,14 L5,14 L5,10 L10,10 L10,5 L14,5 Z M13,6 L11,6 L11,11 L6,11 L6,13 L11,13 L11,18 L13,18 L13,13 L18,13 L18,11 L13,11 L13,6 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-check':
			icon = <CheckMarkIcon {...svgProps} color={color} />;
			break;
		case 'sc-calendar':
			icon = (
				<svg {...svgProps} viewBox="0 0 36.447 36.447">
					<path
						d="M30.224,3.948h-1.098V2.75c0-1.516-1.197-2.75-2.67-2.75c-1.474,0-2.67,1.234-2.67,2.75v1.197h-2.74V2.75
			c0-1.516-1.197-2.75-2.67-2.75c-1.473,0-2.67,1.234-2.67,2.75v1.197h-2.74V2.75c0-1.516-1.197-2.75-2.67-2.75
			c-1.473,0-2.67,1.234-2.67,2.75v1.197H6.224c-2.343,0-4.25,1.907-4.25,4.25v24c0,2.343,1.907,4.25,4.25,4.25h24
			c2.344,0,4.25-1.907,4.25-4.25v-24C34.474,5.854,32.567,3.948,30.224,3.948z M25.286,2.75c0-0.689,0.525-1.25,1.17-1.25
			c0.646,0,1.17,0.561,1.17,1.25v4.895c0,0.689-0.524,1.25-1.17,1.25c-0.645,0-1.17-0.561-1.17-1.25V2.75z M17.206,2.75
			c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25v4.895c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75z M9.125,2.75
			c0-0.689,0.525-1.25,1.17-1.25s1.17,0.561,1.17,1.25v4.895c0,0.689-0.525,1.25-1.17,1.25s-1.17-0.561-1.17-1.25V2.75z
			 M31.974,32.198c0,0.965-0.785,1.75-1.75,1.75h-24c-0.965,0-1.75-0.785-1.75-1.75v-22h27.5V32.198z"
					/>
				</svg>
			);
			break;
		case 'sc-standalone':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M20.25,9.25 L20.25,16.7180574 L20.2478355,16.8724567 C20.2377602,17.2042482 20.192693,17.3458303 20.1164336,17.4884229 C20.0292801,17.6513858 19.9013858,17.7792801 19.7384229,17.8664336 C19.5754599,17.9535872 19.4138168,18 18.9680574,18 L18.9680574,18 L5.0319426,18 L4.87754329,17.9978355 C4.54575183,17.9877602 4.40416974,17.942693 4.26157715,17.8664336 C4.09861419,17.7792801 3.9707199,17.6513858 3.88356635,17.4884229 C3.79641281,17.3254599 3.75,17.1638168 3.75,16.7180574 L3.75,16.7180574 L3.75,9.25 L20.25,9.25 Z M18.9680574,5.75 L19.1224567,5.75216452 C19.4542482,5.76223978 19.5958303,5.807307 19.7384229,5.88356635 C19.9013858,5.9707199 20.0292801,6.09861419 20.1164336,6.26157715 C20.2035872,6.42454011 20.25,6.58618323 20.25,7.0319426 L20.25,7.0319426 L20.25,8.25 L3.75,8.25 L3.75,7.0319426 L3.75216452,6.87754329 C3.76223978,6.54575183 3.807307,6.40416974 3.88356635,6.26157715 C3.9707199,6.09861419 4.09861419,5.9707199 4.26157715,5.88356635 C4.42454011,5.79641281 4.58618323,5.75 5.0319426,5.75 L5.0319426,5.75 L18.9680574,5.75 Z M5,6.5 C4.72385763,6.5 4.5,6.72385763 4.5,7 C4.5,7.27614237 4.72385763,7.5 5,7.5 C5.27614237,7.5 5.5,7.27614237 5.5,7 C5.5,6.72385763 5.27614237,6.5 5,6.5 Z M6.75,6.5 C6.47385763,6.5 6.25,6.72385763 6.25,7 C6.25,7.27614237 6.47385763,7.5 6.75,7.5 C7.02614237,7.5 7.25,7.27614237 7.25,7 C7.25,6.72385763 7.02614237,6.5 6.75,6.5 Z M8.5,6.5 C8.22385763,6.5 8,6.72385763 8,7 C8,7.27614237 8.22385763,7.5 8.5,7.5 C8.77614237,7.5 9,7.27614237 9,7 C9,6.72385763 8.77614237,6.5 8.5,6.5 Z M18.6861148,4.75 C19.5776335,4.75 19.9009198,4.84282561 20.2268457,5.0171327 C20.5527716,5.1914398 20.8085602,5.44722837 20.9828673,5.7731543 C21.1571744,6.09908022 21.25,6.42236646 21.25,7.3138852 L21.25,16.4361148 C21.25,17.3276335 21.1571744,17.6509198 20.9828673,17.9768457 C20.8085602,18.3027716 20.5527716,18.5585602 20.2268457,18.7328673 C19.9009198,18.9071744 19.5776335,19 18.6861148,19 L5.3138852,19 C4.42236646,19 4.09908022,18.9071744 3.7731543,18.7328673 C3.44722837,18.5585602 3.1914398,18.3027716 3.0171327,17.9768457 C2.85623385,17.675991 2.764763,17.3773855 2.75164263,16.6320228 L2.75,7.3138852 C2.75,6.42236646 2.84282561,6.09908022 3.0171327,5.7731543 C3.1914398,5.44722837 3.44722837,5.1914398 3.7731543,5.0171327 C4.09908022,4.84282561 4.42236646,4.75 5.3138852,4.75 L18.6861148,4.75 Z"
							fill="#000"
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-embed':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M19.25,19.25 C19.5261424,19.25 19.75,19.4738576 19.75,19.75 C19.75,20.0261424 19.5261424,20.25 19.25,20.25 L4.75,20.25 C4.47385763,20.25 4.25,20.0261424 4.25,19.75 C4.25,19.4738576 4.47385763,19.25 4.75,19.25 L19.25,19.25 Z M19.25,17 C19.5261424,17 19.75,17.2238576 19.75,17.5 C19.75,17.7761424 19.5261424,18 19.25,18 L4.75,18 C4.47385763,18 4.25,17.7761424 4.25,17.5 C4.25,17.2238576 4.47385763,17 4.75,17 L19.25,17 Z M17.1861148,6.75 C18.0776335,6.75 18.4009198,6.84282561 18.7268457,7.0171327 C19.0527716,7.1914398 19.3085602,7.44722837 19.4828673,7.7731543 C19.6571744,8.09908022 19.75,8.42236646 19.75,9.3138852 L19.75,12.9361148 C19.75,13.8276335 19.6571744,14.1509198 19.4828673,14.4768457 C19.3085602,14.8027716 19.0527716,15.0585602 18.7268457,15.2328673 C18.4009198,15.4071744 18.0776335,15.5 17.1861148,15.5 L6.8138852,15.5 C5.92236646,15.5 5.59908022,15.4071744 5.2731543,15.2328673 C4.94722837,15.0585602 4.6914398,14.8027716 4.5171327,14.4768457 C4.35623385,14.175991 4.264763,13.8773855 4.25164263,13.1320228 L4.25,9.3138852 C4.25,8.42236646 4.34282561,8.09908022 4.5171327,7.7731543 C4.6914398,7.44722837 4.94722837,7.1914398 5.2731543,7.0171327 C5.59908022,6.84282561 5.92236646,6.75 6.8138852,6.75 L17.1861148,6.75 Z M12.8889294,9.41129704 L12.4209183,9.9008325 L13.6315632,11.1661771 L12.4209183,12.4325008 L12.8889294,12.9220363 L14.5671174,11.1666667 L12.8889294,9.41129704 Z M10.6421958,9.41129704 L8.96400778,11.1666667 L10.6421958,12.9220363 L11.1102069,12.4325008 L9.89956205,11.1661771 L11.1102069,9.9008325 L10.6421958,9.41129704 Z M19.25,4.25 C19.5261424,4.25 19.75,4.47385763 19.75,4.75 C19.75,5.02614237 19.5261424,5.25 19.25,5.25 L4.75,5.25 C4.47385763,5.25 4.25,5.02614237 4.25,4.75 C4.25,4.47385763 4.47385763,4.25 4.75,4.25 L19.25,4.25 Z M17.4680574,7.75 L6.5319426,7.75 C6.08618323,7.75 5.92454011,7.79641281 5.76157715,7.88356635 C5.59861419,7.9707199 5.4707199,8.09861419 5.38356635,8.26157715 C5.307307,8.40416974 5.26223978,8.54575183 5.25216452,8.87754329 L5.25,9.0319426 L5.25,13.2180574 C5.25,13.6638168 5.29641281,13.8254599 5.38356635,13.9884229 C5.4707199,14.1513858 5.59861419,14.2792801 5.76157715,14.3664336 C5.90416974,14.442693 6.04575183,14.4877602 6.37754329,14.4978355 L6.5319426,14.5 L17.4680574,14.5 C17.9138168,14.5 18.0754599,14.4535872 18.2384229,14.3664336 C18.4013858,14.2792801 18.5292801,14.1513858 18.6164336,13.9884229 C18.692693,13.8458303 18.7377602,13.7042482 18.7478355,13.3724567 L18.75,13.2180574 L18.75,9.0319426 C18.75,8.58618323 18.7035872,8.42454011 18.6164336,8.26157715 C18.5292801,8.09861419 18.4013858,7.9707199 18.2384229,7.88356635 C18.0958303,7.807307 17.9542482,7.76223978 17.6224567,7.75216452 L17.4680574,7.75 Z"
							fill="#000"
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-publish':
			icon = <Publish {...svgProps} color={color} />;
			break;
		case 'sc-symbol-add':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M18.25,14 L18.25,17 L21.25,17 L21.25,18 L18.25,18 L18.25,21 L17.25,21 L17.25,18 L14.25,18 L14.25,17 L17.25,17 L17.25,14 L18.25,14 Z M11.25,6 L11.25,8 C11.25,8.55228475 11.6977153,9 12.25,9 C12.8022847,9 13.25,8.55228475 13.25,8 L13.25,6 L17.25,6 C17.8022847,6 18.25,6.44771525 18.25,7 L18.25,10 L17.25,10 L17.25,7 L14.25,7 L14.25,8 C14.25,9.0543618 13.4341222,9.91816512 12.3992623,9.99451426 L12.25,10 C11.1956382,10 10.3318349,9.18412221 10.2554857,8.14926234 L10.25,8 L10.25,7 L7.25,7 L7.25,11 L5.25,11 C4.69771525,11 4.25,11.4477153 4.25,12 C4.25,12.5522847 4.69771525,13 5.25,13 L7.25,13 L7.25,17 L10.25,17 L10.25,18 L7.25,18 C6.69771525,18 6.25,17.5522847 6.25,17 L6.25,14 L5.25,14 C4.1956382,14 3.33183488,13.1841222 3.25548574,12.1492623 L3.25,12 C3.25,10.9456382 4.06587779,10.0818349 5.10073766,10.0054857 L5.25,10 L6.25,10 L6.25,7 C6.25,6.44771525 6.69771525,6 7.25,6 L11.25,6 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-bind':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M10,8 L10,9 L7,9 C5.34314575,9 4,10.3431458 4,12 C4,13.6568542 5.34314575,15 7,15 L10,15 L10,16 L7,16 C4.85780461,16 3.10892112,14.3160315 3.00489531,12.1996403 L3,12 C3,9.85780461 4.68396847,8.10892112 6.80035966,8.00489531 L7,8 L10,8 Z M17,8 C19.209139,8 21,9.790861 21,12 C21,14.1421954 19.3160315,15.8910789 17.1996403,15.9951047 L17,16 L13.75,16 L13.75,15 L17,15 C18.6568542,15 20,13.6568542 20,12 C20,10.3431458 18.6568542,9 17,9 L13.75,9 L13.75,8 L17,8 Z M15,11.375 L15,12.375 L9,12.375 L9,11.375 L15,11.375 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-unbind':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M9,8 L9,9 L7,9 C5.34314575,9 4,10.3431458 4,12 C4,13.6568542 5.34314575,15 7,15 L9,15 L9,16 L7,16 C4.85780461,16 3.10892112,14.3160315 3.00489531,12.1996403 L3,12 C3,9.790861 4.790861,8 7,8 L7,8 L9,8 Z M17,8 C19.209139,8 21,9.790861 21,12 C21,14.209139 19.209139,16 17,16 L17,16 L15,16 L15,15 L17,15 C18.6568542,15 20,13.6568542 20,12 C20,10.3431458 18.6568542,9 17,9 L15,9 L15,8 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'sc-loop':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M4.5,9 L4.5,13 L8.25,13 L8.25,15 L4.5,15 C3.3954305,15 2.5,14.1045695 2.5,13 L2.5,13 L2.5,9 C2.5,7.8954305 3.3954305,7 4.5,7 L4.5,7 L19.5,7 C20.6045695,7 21.5,7.8954305 21.5,9 L21.5,13 C21.5,14.1045695 20.6045695,15 19.5,15 L12.5,15 L12.5,17 L9.5,14 L12.5,11 L12.5,13 L19.5,13 L19.5,12 L19.5,12 L19.5,9 L4.5,9 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;

		case PROP_FIELD_ICONS.GENERAL:
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						d="M19,4a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H19m0-1H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Z"
					/>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.BORDERS:
			icon = (
				<svg {...svgProps}>
					<rect fill={color} x="5" y="20" width="14" height="1" />
					<rect fill={color} x="5" y="3" width="14" height="1" />
					<rect fill={color} x="3" y="5" width="1" height="14" />
					<rect fill={color} x="20" y="5" width="1" height="14" />
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.CSS:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g transform="translate(4.000000, 9.000000)" fill={color} fillRule="nonzero">
							<path d="M2.46153846,1.2 C3.14126923,1.2 3.69230769,1.7372625 3.69230769,2.4 L4.92307692,2.4 C4.92307692,1.074525 3.821,0 2.46153846,0 C1.10207692,0 0,1.074525 0,2.4 L0,3.6 C0,4.925475 1.10207692,6 2.46153846,6 C3.821,6 4.92307692,4.925475 4.92307692,3.6 L3.69230769,3.6 C3.69230769,4.2627375 3.14126923,4.8 2.46153846,4.8 C1.78180769,4.8 1.23076923,4.2627375 1.23076923,3.6 L1.23076923,2.4 C1.23076923,1.7372625 1.78180769,1.2 2.46153846,1.2 Z" />
							<path d="M14.1538462,2.4 L12.9230769,2.4 C12.5831923,2.4 12.3076923,2.1313875 12.3076923,1.8 C12.3076923,1.4686125 12.5831923,1.2 12.9230769,1.2 L14.1538462,1.2 C14.4937308,1.2 14.7692308,1.4686125 14.7692308,1.8 L16,1.8 C16,0.805875 15.1734615,0 14.1538462,0 L12.9230769,0 C11.9034615,0 11.0769231,0.805875 11.0769231,1.8 C11.0769231,2.794125 11.9034615,3.6 12.9230769,3.6 L14.1538462,3.6 C14.4937308,3.6 14.7692308,3.8686125 14.7692308,4.2 C14.7692308,4.5313875 14.4937308,4.8 14.1538462,4.8 L12.9230769,4.8 C12.5831923,4.8 12.3076923,4.5313875 12.3076923,4.2 L11.0769231,4.2 C11.0769231,5.194125 11.9034615,6 12.9230769,6 L14.1538462,6 C15.1734615,6 16,5.194125 16,4.2 C16,3.2059125 15.1734615,2.4 14.1538462,2.4 Z" />
							<path d="M7.38461538,1.2 L8.61538462,1.2 C8.95526923,1.2 9.23076923,1.4686125 9.23076923,1.8 L10.4615385,1.8 C10.4615385,0.805875 9.635,0 8.61538462,0 L7.38461538,0 C6.365,0 5.53846154,0.805875 5.53846154,1.8 C5.53846154,2.794125 6.365,3.6 7.38461538,3.6 L8.61538462,3.6 C8.95526923,3.6 9.23076923,3.8686125 9.23076923,4.2 C9.23076923,4.5313875 8.95526923,4.8 8.61538462,4.8 L7.38461538,4.8 C7.04473077,4.8 6.76923077,4.5313875 6.76923077,4.2 L5.53846154,4.2 C5.53846154,5.194125 6.365,6 7.38461538,6 L8.61538462,6 C9.635,6 10.4615385,5.194125 10.4615385,4.2 C10.4615385,3.205875 9.635,2.4 8.61538462,2.4 L7.38461538,2.4 C7.04473077,2.4 6.76923077,2.1313875 6.76923077,1.8 C6.76923077,1.4686125 7.04476923,1.2 7.38461538,1.2 Z" />
						</g>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.EFFECTS:
			icon = (
				<svg {...svgProps}>
					<polygon fill={color} points="17 10.11 13.51 10.11 14.33 2 7 13.35 10.51 13.35 9.67 22 17 10.11" />
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.LAYOUT:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(8.000000, 7.207000)" fill={color}>
							<path d="M1,0.793 L7,0.793 C7.55228475,0.793 8,1.24071525 8,1.793 L8,7.793 C8,8.34528475 7.55228475,8.793 7,8.793 L1,8.793 C0.44771525,8.793 6.76353751e-17,8.34528475 0,7.793 L0,1.793 C-6.76353751e-17,1.24071525 0.44771525,0.793 1,0.793 Z" />
						</g>
						<path
							d="M7,4 L7,6 L17,6 L17,4 L18,4 L18,6 L20,6 L20,7 L18,7 L18,17 L20,17 L20,18 L18,18 L18,20 L17,20 L17,18 L7,18 L7,20 L6,20 L6,18 L4,18 L4,17 L6,17 L6,7 L4,7 L4,6 L6,6 L6,4 L7,4 Z M17,7 L7,7 L7,17 L17,17 L17,7 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.POSITION:
			icon = (
				<svg {...svgProps}>
					<path
						fillOpacity="0.35"
						fill={color}
						d="M15,9v6H9V9h6m0-1H9A1,1,0,0,0,8,9v6a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1Z"
					/>
					<polygon fill={color} points="10 4 11.5 4 11.5 7 12.5 7 12.5 4 14 4 14 3 10 3 10 4" />
					<polygon fill={color} points="12.5 17 11.5 17 11.5 20 10 20 10 21 14 21 14 20 12.5 20 12.5 17" />
					<polygon fill={color} points="20 10 20 11.5 17 11.5 17 12.5 20 12.5 20 14 21 14 21 10 20 10" />
					<polygon fill={color} points="4 10 3 10 3 14 4 14 4 12.5 7 12.5 7 11.5 4 11.5 4 10" />
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SETTINGS:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(4.434000, 4.000000)" fill={color}>
							<path d="M8.841,0 L8.90329945,0.318340432 L8.95209745,0.532988224 C9.17308746,1.38256935 9.7008258,2.12008489 10.4335138,2.60351312 L10.6208967,2.7189945 L10.8147458,2.82255084 C11.6001866,3.2115512 12.5013911,3.29740424 13.3465829,3.06401657 L13.5566145,2.9990095 L13.857,2.895 L15.131,5.105 L14.8866246,5.31800313 L14.7253063,5.4671682 C14.1006042,6.08167907 13.7247808,6.90596354 13.6706583,7.78043022 L13.6638719,8 L13.6706583,8.21956976 C13.7247806,9.09403628 14.1006016,9.91831865 14.7252721,10.5328021 L14.886582,10.6819598 L15.131,10.894 L13.856,13.104 L13.5587623,13.001731 L13.3483025,12.9365763 C12.5015234,12.7026414 11.6001968,12.7884523 10.8147466,13.1774494 L10.6208967,13.2810055 L10.4335139,13.3964868 C9.70082613,13.8799135 9.17309164,14.6174092 8.95215183,15.4667327 L8.90336737,15.681311 L8.841,16 L6.291,16 L6.22919432,15.6816596 L6.18039632,15.4670118 C5.95940632,14.6174307 5.43166797,13.8799151 4.69897994,13.3964869 L4.51159706,13.2810055 L4.31772896,13.1774479 C3.53214177,12.7884385 2.63000931,12.702536 1.78529414,12.9360961 L1.57541221,13.0011511 L1.275,13.105 L1.58095759e-13,10.894 L0.245869173,10.6819969 L0.407187514,10.5328318 C1.03188956,9.91832093 1.40771298,9.09403646 1.4618355,8.21956978 L1.46862189,8 L1.46183552,7.78043024 C1.40771318,6.90596372 1.03189219,6.08168135 0.40722166,5.46719787 L0.245911821,5.31804018 L1.58095759e-13,5.105 L1.275,2.895 L1.57373151,2.99826902 L1.78394848,3.06343958 C2.6299058,3.29742826 3.53213381,3.21155879 4.31772835,2.82255191 L4.51159706,2.7189945 L4.69897991,2.60351324 C5.43166765,2.12008654 5.95940213,1.38259081 6.18034195,0.533267276 L6.22912641,0.318688962 L6.291,0 L8.841,0 Z M7.566,3.5 C5.086,3.5 3.066,5.52 3.066,8 C3.066,10.48 5.086,12.5 7.566,12.5 C10.046,12.5 12.066,10.48 12.066,8 C12.066,5.52 10.046,3.5 7.566,3.5 Z" />
						</g>
						<path
							d="M13.7687469,3 C13.9326755,3 14.0775938,3.1000102 14.1390326,3.2468965 L14.1624969,3.324 L14.3188719,4.12725 C14.4606219,4.854 14.9106219,5.482875 15.5529969,5.851875 C16.1369742,6.18732955 16.8260134,6.2782593 17.4730448,6.11114059 L17.6657469,6.05325 L18.4329969,5.78775 C18.5882469,5.73471429 18.7575479,5.78168878 18.8629699,5.90104373 L18.9099969,5.966625 L20.6784969,9.033375 C20.7604612,9.17608929 20.7465479,9.35103827 20.6495093,9.47745809 L20.5941219,9.53625 L19.9764969,10.072875 C19.4184969,10.55775 19.0978719,11.260875 19.0978719,12 C19.0978719,12.6775312 19.367286,13.3248125 19.8419904,13.8014648 L19.9764969,13.927125 L20.5941219,14.46375 C20.7185147,14.57175 20.7619076,14.7417398 20.7115483,14.8929555 L20.6784969,14.966625 L18.9099969,18.033375 C18.8280326,18.1760893 18.669201,18.2510281 18.511432,18.2305616 L18.4329969,18.21225 L17.6657469,17.94675 C16.9648719,17.706 16.1953719,17.779125 15.5529969,18.148125 C14.9641531,18.486375 14.5369578,19.0429922 14.3606642,19.6931953 L14.3188719,19.87275 L14.1624969,20.676 C14.1306755,20.8370357 14.0046295,20.960051 13.8488285,20.9919118 L13.7687469,21 L10.2317469,21 C10.066854,21 9.92262444,20.8999898 9.86140214,20.7531035 L9.83799689,20.676 L9.68162189,19.87275 C9.53987189,19.146 9.08987189,18.517125 8.44749689,18.148125 C7.86351962,17.8126705 7.17355061,17.7217407 6.52719542,17.8888594 L6.33474689,17.94675 L5.56749689,18.21225 C5.41224689,18.2652857 5.24294587,18.2183112 5.13752386,18.0989563 L5.09049689,18.033375 L3.32199689,14.966625 C3.23906832,14.8239107 3.25367036,14.6489617 3.35092546,14.5225419 L3.40637189,14.46375 L4.02399689,13.927125 C4.58199689,13.44225 4.90262189,12.739125 4.90262189,12 C4.90262189,11.3224688 4.63320783,10.6751875 4.1585034,10.1985352 L4.02399689,10.072875 L3.40637189,9.53625 C3.28197903,9.42825 3.23775964,9.2582602 3.28859128,9.10704446 L3.32199689,9.033375 L5.09049689,5.966625 C5.17246117,5.82391071 5.33129281,5.74897194 5.48906176,5.76943841 L5.56749689,5.78775 L6.33474689,6.05325 C7.03449689,6.294 7.80512189,6.220875 8.44749689,5.851875 C9.03634064,5.513625 9.46353595,4.95700781 9.63982957,4.30680469 L9.68162189,4.12725 L9.83799689,3.324 C9.86981832,3.16296429 9.99503771,3.03994898 10.151311,3.00808819 L10.2317469,3 L13.7687469,3 Z M13.275,4 L10.725,4 L10.6631264,4.31868896 C10.4799346,5.25791049 9.92672496,6.07980098 9.13297991,6.60351324 L8.94559706,6.7189945 C8.11689591,7.19502598 7.13440225,7.31692732 6.21794848,7.06343958 L6.00773151,6.99826902 L5.709,6.895 L4.434,9.105 L4.67991182,9.31804018 C5.40102134,9.94464946 5.83720298,10.8330915 5.89583552,11.7804302 L5.90262189,12 C5.90262189,12.955199 5.51794807,13.8671117 4.84118751,14.5328318 L4.67986917,14.6819969 L4.434,14.894 L5.709,17.105 L6.00941221,17.0011511 C6.91284456,16.6903239 7.90067617,16.756021 8.75172896,17.1774479 L8.94559706,17.2810055 C9.77558139,17.7577741 10.3749905,18.5466322 10.6143963,19.4670118 L10.6631943,19.6816596 L10.725,20 L13.275,20 L13.3373674,19.681311 C13.5205592,18.7420895 14.0737688,17.920199 14.8675139,17.3964868 L15.0548967,17.2810055 C15.8835969,16.8049746 16.8649585,16.6831468 17.7823025,16.9365763 L17.9927623,17.001731 L18.29,17.104 L19.565,14.894 L19.320582,14.6819598 C18.5994724,14.0553505 18.1632908,13.1669085 18.1046583,12.2195698 L18.0978719,12 C18.0978719,11.044801 18.4825457,10.1328883 19.1593063,9.4671682 L19.3206246,9.31800313 L19.565,9.105 L18.291,6.895 L17.9906145,6.9990095 C17.0863958,7.30960789 16.09964,7.2439679 15.2487458,6.82255084 L15.0548967,6.7189945 C14.2249124,6.24222592 13.6255033,5.45336777 13.3860975,4.53298822 L13.3372995,4.31834043 L13.275,4 Z M12,7.5 C14.48,7.5 16.5,9.52 16.5,12 C16.5,14.48 14.48,16.5 12,16.5 C9.52,16.5 7.5,14.48 7.5,12 C7.5,9.52 9.52,7.5 12,7.5 Z M12,8.5 C10.0722847,8.5 8.5,10.0722847 8.5,12 C8.5,13.9277153 10.0722847,15.5 12,15.5 C13.9277153,15.5 15.5,13.9277153 15.5,12 C15.5,10.0722847 13.9277153,8.5 12,8.5 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SIZE:
			icon = (
				<svg {...svgProps}>
					<path
						fill={color}
						fillOpacity="0.35"
						d="M19,4a1,1,0,0,1,1,1V19a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H19m0-1H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5a2,2,0,0,0-2-2Z"
					/>
					<polygon fill={color} points="19 8 9 8 9 5 8 5 8 8 5 8 5 9 8 9 8 19 9 19 9 9 19 9 19 8" />
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.TEXT:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M14.5,19 L14.5,18 C13.9477153,18 13.5,17.5522847 13.5,17 L13.5,8 L13.5,8 L16,8 C16.5522847,8 17,8.44771525 17,9 L17,9 L17,9 L18,9 L18,6 L6,6 L6,9 L7,9 C7,8.44771525 7.44771525,8 8,8 L10.5,8 L10.5,8 L10.5,17 C10.5,17.5522847 10.0522847,18 9.5,18 L9.5,18 L9.5,18 L9.5,19 L14.5,19 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.LINK:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M7,16 C4.790861,16 3,14.209139 3,12 C3,9.790861 4.790861,8 7,8 L10.0018166,7.99845797 C9.31483279,8.51398534 8.76493708,9.2022858 8.41662051,9.99886828 L7,10 C5.8954305,10 5,10.8954305 5,12 C5,13.1045695 5.8954305,14 7,14 L7,14 L11,14 C12.1045695,14 13,13.1045695 13,12 C13,11.6489477 12.909554,11.3190203 12.7506935,11.0322491 C12.7936211,11.0202934 12.8380375,11.0119941 12.8833789,11.0067277 L13,11 L14.8740452,11.0002435 C14.9562692,11.3197901 15,11.6547881 15,12 C15,14.209139 13.209139,16 11,16 L7,16 Z M17,8 C19.209139,8 21,9.790861 21,12 C21,14.209139 19.209139,16 17,16 L13.9981834,16.001542 C14.6851672,15.4860147 15.2350629,14.7977142 15.5833795,14.0011317 L17,14 C18.1045695,14 19,13.1045695 19,12 C19,10.8954305 18.1045695,10 17,10 L17,10 L13,10 C11.8954305,10 11,10.8954305 11,12 C11,12.3510523 11.090446,12.6809797 11.2493065,12.9677509 C11.2063789,12.9797066 11.1619625,12.9880059 11.1166211,12.9932723 L11,13 L9.12595483,12.9997565 C9.04373079,12.6802099 9,12.3452119 9,12 C9,9.790861 10.790861,8 13,8 L17,8 Z"
							transform="translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) "
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.STATE:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
						<g opacity="0.5" transform="translate(4.250000, 4.957000)">
							<path d="M5.74261154,0.0298676632 C5.22333727,0.0298676632 4.79582769,0.422758965 4.74113429,0.927490054 L4.73522307,1.03725613 L4.73522307,9.94152133 L1.42084346,8.25940559 C1.09391701,8.0934837 0.706252471,8.12110779 0.408350463,8.32254756 L0.301138775,8.40619655 L0.097,8.588 L4.9490398,13.4550706 C5.28259123,13.7896337 5.72231954,13.9939548 6.1891961,14.035229 L6.36539304,14.043 L11.7516644,14.043 C12.8060262,14.043 13.6698295,13.2271222 13.7461787,12.1922623 L13.7516644,12.043 L13.7516644,7.64053017 C13.7516644,6.69758972 13.0947827,5.89059575 12.1878434,5.68860465 L12.0344412,5.66062177 L6.75,4.90588105 L6.75,1.03725613 C6.75,0.480890841 6.29897682,0.0298676632 5.74261154,0.0298676632 Z" />
						</g>
						<path d="M9.99261154,3.98686766 C11.1012616,3.98686766 12,4.88560609 12,5.99425613 L12,8.9955565 L16.4258296,9.62766757 C17.9038204,9.83875892 19.0016644,11.1045411 19.0016644,12.5975302 L19.0016644,17 C19.0016644,18.6568542 17.6585186,20 16.0016644,20 L10.615393,20 C9.81816942,20 9.05373122,19.6826811 8.49086319,19.118106 L2.89431398,13.5045833 L3.88400466,12.6182589 C4.49850172,12.0679418 5.38782951,11.9513527 6.12341404,12.324677 L7.98522307,13.2695833 L7.98522307,5.99425613 C7.98522307,4.88560609 8.8839615,3.98686766 9.99261154,3.98686766 Z M9.99261154,4.98686766 C9.47333727,4.98686766 9.04582769,5.37975896 8.99113429,5.88449005 L8.98522307,5.99425613 L8.98522307,14.8985213 L5.67084346,13.2164056 C5.34391701,13.0504837 4.95625247,13.0781078 4.65835046,13.2795476 L4.55113877,13.3631965 L4.347,13.545 L9.1990398,18.4120706 C9.53259123,18.7466337 9.97231954,18.9509548 10.4391961,18.992229 L10.615393,19 L16.0016644,19 C17.0560262,19 17.9198295,18.1841222 17.9961787,17.1492623 L18.0016644,17 L18.0016644,12.5975302 C18.0016644,11.6545897 17.3447827,10.8475957 16.4378434,10.6456046 L16.2844412,10.6176218 L11,9.86288105 L11,5.99425613 C11,5.43789084 10.5489768,4.98686766 9.99261154,4.98686766 Z" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.ERROR:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill={color} fillRule="evenodd">
						<path
							d="M12.6289915,6.17231541 C12.9104907,6.34121494 13.1460863,6.57681054 13.3149859,6.85830975 L19.3826051,16.9710085 C19.9509014,17.918169 19.6437713,19.1466895 18.6966108,19.7149859 C18.3857799,19.9014843 18.0301071,20 17.6676192,20 L5.53238076,20 C4.42781126,20 3.53238076,19.1045695 3.53238076,18 C3.53238076,17.6375121 3.63089642,17.2818393 3.81739491,16.9710085 L9.88501415,6.85830975 C10.4533105,5.91114922 11.681831,5.60401909 12.6289915,6.17231541 Z M11.5589305,16.1101604 C11.2487701,16.1101604 10.9833957,16.2184492 10.7628075,16.4350267 C10.5422193,16.6516043 10.433262,16.9122995 10.4359358,17.2171123 C10.433262,17.5299465 10.5422193,17.7953209 10.7628075,18.0132353 C10.9833957,18.2311497 11.2487701,18.340107 11.5589305,18.340107 C11.7567914,18.340107 11.9399465,18.2899733 12.1083957,18.1897059 C12.2768449,18.0894385 12.413877,17.9544118 12.519492,17.7846257 C12.625107,17.6148396 12.6792513,17.4256684 12.6819251,17.2171123 C12.6792513,16.9122995 12.5649465,16.6516043 12.3390107,16.4350267 C12.1130749,16.2184492 11.8530481,16.1101604 11.5589305,16.1101604 Z M12.6819251,9.99786096 L10.4359358,9.99786096 L10.644492,15.6449198 L12.473369,15.6449198 L12.6819251,9.99786096 Z"
							fillOpacity="0.95"
						/>
					</g>
				</svg>
			);
			break;

		case 'mail':
			icon = (
				<svg {...svgProps}>
					<defs>
						<rect x="0" y="0" width="40" height="40" rx="12" />
						<filter x="-1.2%" y="-1.2%" width="102.5%" height="102.5%" filterUnits="objectBoundingBox">
							<feMorphology radius="1" operator="erode" in="SourceAlpha" result="shadowSpreadInner1" />
							<feOffset dx="0" dy="0" in="shadowSpreadInner1" result="shadowOffsetInner1" />
							<feComposite
								in="shadowOffsetInner1"
								in2="SourceAlpha"
								operator="arithmetic"
								k2="-1"
								k3="1"
								result="shadowInnerInner1"
							/>
							<feColorMatrix
								values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0"
								type="matrix"
								in="shadowInnerInner1"
							/>
						</filter>
					</defs>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g transform="translate(-8.000000, -8.000000)">
							<path
								d="M15.3833112,-6.21504185e-16 L24.6166888,6.21504185e-16 C29.9658012,-3.61111829e-16 31.9055187,0.556953667 33.8610742,1.60279622 C35.8166298,2.64863878 37.3513612,4.18337022 38.3972038,6.13892578 C39.4430463,8.09448133 40,10.0341988 40,15.3833112 L40,24.6166888 C40,29.9658012 39.4430463,31.9055187 38.3972038,33.8610742 C37.3513612,35.8166298 35.8166298,37.3513612 33.8610742,38.3972038 C31.9055187,39.4430463 29.9658012,40 24.6166888,40 L15.3833112,40 C10.0341988,40 8.09448133,39.4430463 6.13892578,38.3972038 C4.18337022,37.3513612 2.64863878,35.8166298 1.60279622,33.8610742 C0.556953667,31.9055187 2.4074122e-16,29.9658012 -4.14336123e-16,24.6166888 L4.14336123e-16,15.3833112 C-2.4074122e-16,10.0341988 0.556953667,8.09448133 1.60279622,6.13892578 C2.64863878,4.18337022 4.18337022,2.64863878 6.13892578,1.60279622 C8.09448133,0.556953667 10.0341988,3.61111829e-16 15.3833112,-6.21504185e-16 Z"
								fillOpacity="0"
								fill="#000000"
							/>
							<g fill="black" fillOpacity="1">
								<use filter="url(#filter-2)" xlinkHref="#path-1" />
							</g>
							<g transform="translate(8.000000, 8.000000)">
								<path
									d="M20,4 L4,4 C2.9,4 2.01,4.9 2.01,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 C22,4.9 21.1,4 20,4 Z M20,8 L12,13 L4,8 L4,6 L12,11 L20,6 L20,8 Z"
									fillOpacity="0.38"
									fill="#000000"
								/>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.LINE_HEIGHT:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(4.000000, 7.207000)" fill={color}>
							<path d="M4.65639109,2.62926744 L5.84957177,3.0554034 C6.12656014,2.45881306 6.78174418,1.81960912 7.98025156,1.81960912 C9.13614534,1.81960912 9.70610218,2.43217956 9.70610218,3.48153935 L9.70610218,3.52415295 C9.70610218,4.13139669 9.08820505,4.07812969 7.5967292,4.26989087 C6.07861985,4.46697875 4.42201631,4.80256082 4.42201631,6.67755903 C4.42201631,7.6562935 4.88558815,8.37926419 5.60223627,8.79262341 L0,8.793 L0,0.793 L7.04455727,0.79163104 C6.07953623,0.972834903 5.14440911,1.49055874 4.65639109,2.62926744 Z M9.70610218,7.89204651 L9.706,8.79238564 L8.78360441,8.7937212 C9.22914473,8.52805953 9.50559183,8.17660892 9.64218179,7.89204651 L9.70610218,7.89204651 Z M16,0.793 L16,8.793 L10.963,8.79238564 L10.9632033,3.60938014 C10.9632033,1.64011549 9.82596026,0.991520128 8.82063597,0.792782375 L16,0.793 Z M9.70610218,4.88778801 L9.70610218,6.0383551 C9.70610218,7.06108139 8.89644386,8.06250089 7.40496801,8.06250089 C6.40354852,8.06250089 5.67911739,7.61505814 5.67911739,6.74147943 C5.67911739,5.78267352 6.5526961,5.48437835 7.5328088,5.35653757 C8.06547875,5.29261717 9.49303421,5.14346959 9.70610218,4.88778801 Z" />
						</g>
						<path d="M20,16 L20,17 L4,17 L4,16 L20,16 Z M20,7 L20,8 L4,8 L4,7 L20,7 Z" fill={color} />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.FONT_SIZE:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(8.000000, 7.207000)" fill={color}>
							<path d="M3.21320683,9.19176118 C4.64076229,9.19176118 5.38650022,8.42471646 5.64218179,7.89204651 L5.70610218,7.89204651 L5.70610218,9 L6.96320326,9 L6.96320326,3.60938014 C6.96320326,1.0099508 4.98167106,0.711655632 3.93763796,0.711655632 C2.70184369,0.711655632 1.29559503,1.13779159 0.65639109,2.62926744 L1.84957177,3.0554034 C2.12656014,2.45881306 2.78174418,1.81960912 3.98025156,1.81960912 C5.13614534,1.81960912 5.70610218,2.43217956 5.70610218,3.48153935 L5.70610218,3.52415295 C5.70610218,4.13139669 5.08820505,4.07812969 3.5967292,4.26989087 C2.07861985,4.46697875 0.422016314,4.80256082 0.422016314,6.67755903 C0.422016314,8.27556887 1.65781059,9.19176118 3.21320683,9.19176118 Z M3.40496801,8.06250089 C2.40354852,8.06250089 1.67911739,7.61505814 1.67911739,6.74147943 C1.67911739,5.78267352 2.5526961,5.48437835 3.5328088,5.35653757 C4.06547875,5.29261717 5.49303421,5.14346959 5.70610218,4.88778801 L5.70610218,6.0383551 C5.70610218,7.06108139 4.89644386,8.06250089 3.40496801,8.06250089 Z" />
						</g>
						<rect fill={color} x="4" y="16" width="16" height="3" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.TEXT_ALIGN_LEFT:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M14,15 L14,17 L4,17 L4,15 L14,15 Z M20,11 L20,13 L4,13 L4,11 L20,11 Z M20,7 L20,9 L4,9 L4,7 L20,7 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.TEXT_ALIGN_CENTER:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M17,15 L17,17 L7,17 L7,15 L17,15 Z M20,11 L20,13 L4,13 L4,11 L20,11 Z M20,7 L20,9 L4,9 L4,7 L20,7 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.TEXT_ALIGN_RIGHT:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M20,15 L20,17 L10,17 L10,15 L20,15 Z M20,11 L20,13 L4,13 L4,11 L20,11 Z M20,7 L20,9 L4,9 L4,7 L20,7 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.DIRECTION_LTR:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(6.000000, 4.000000)" fill={color}>
							<path d="M0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 L11,0 L11,2 L9,2 L9,11 L7,11 L7,2 L5,2 L5,11 L3,11 L3,6 C1.34314575,6 2.02906125e-16,4.65685425 0,3 Z" />
						</g>
						<polygon fill={color} points="20 17.5 17 15 17 17 5 17 5 18 17 18 17 20" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.DIRECTION_RTL:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(6.000000, 4.000000)" fill={color}>
							<path d="M0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 L11,0 L11,2 L9,2 L9,11 L7,11 L7,2 L5,2 L5,11 L3,11 L3,6 C1.34314575,6 2.02906125e-16,4.65685425 0,3 Z" />
						</g>
						<polygon
							fill={color}
							transform="translate(11.500000, 17.500000) scale(-1, 1) translate(-11.500000, -17.500000) "
							points="19 17.5 16 15 16 17 4 17 4 18 16 18 16 20"
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.BOX_FRAME:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(5.000000, 5.207000)" />
						<path
							d="M19,5 C19.5522847,5 20,5.44771525 20,6 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,6 C4,5.44771525 4.44771525,5 5,5 L19,5 Z M19,6 L5,6 L5,17 L19,17 L19,6 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.BOX_STACK:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(5.000000, 8.207000)" fill={color}>
							<path d="M14,4.793 L14,5.793 L0,5.793 L0,4.793 L14,4.793 Z M14,0.793 L14,1.793 L0,1.793 L0,0.793 L14,0.793 Z" />
						</g>
						<path
							d="M19,5 C19.5522847,5 20,5.44771525 20,6 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,6 C4,5.44771525 4.44771525,5 5,5 L19,5 Z M19,6 L5,6 L5,17 L19,17 L19,6 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.BOX_GRID:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(5.000000, 5.207000)" fill={color}>
							<path d="M9,7.793 L9,4.793 L5,4.793 L5,7.793 L9,7.793 Z M10,7.793 L14,7.793 L14,8.793 L10,8.793 L10,11.793 L9,11.793 L9,8.793 L5,8.793 L5,11.793 L4,11.793 L4,8.793 L0,8.793 L0,7.793 L4,7.793 L4,4.793 L0,4.793 L0,3.793 L4,3.793 L4,0.793 L5,0.793 L5,3.793 L9,3.793 L9,0.793 L10,0.793 L10,3.793 L14,3.793 L14,4.793 L10,4.793 L10,7.793 Z" />
						</g>
						<path
							d="M19,5 C19.5522847,5 20,5.44771525 20,6 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,6 C4,5.44771525 4.44771525,5 5,5 L19,5 Z M19,6 L5,6 L5,17 L19,17 L19,6 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.CELL_HEIGHT:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(5.000000, 4.207000)" fill={color}>
							<path d="M14,13.793 L14,14.793 L2.27373675e-12,14.793 L2.27373675e-12,13.793 L14,13.793 Z M14,0.793 L14,1.793 L2.27373675e-12,1.793 L2.27373675e-12,0.793 L14,0.793 Z" />
						</g>
						<polygon fill={color} points="13 16 13 8 12 7 11 8 11 16 12 17" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.CELL_WIDTH:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(5.000000, 4.207000)" fill={color}>
							<path d="M14,0.793 L14,14.793 L13,14.793 L13,0.793 L14,0.793 Z M1,0.793 L1,14.793 L2.27373675e-12,14.793 L2.27373675e-12,0.793 L1,0.793 Z" />
						</g>
						<polygon fill={color} points="16 11 8 11 7 12 8 13 16 13 17 12" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.GAP_COL:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(4.000000, 5.207000)" fill={color}>
							<path
								d="M13,-1.207 C13.5522847,-1.207 14,-0.75928475 14,-0.207 L14,2.793 C14,3.34528475 13.5522847,3.793 13,3.793 L3,3.793 C2.44771525,3.793 2,3.34528475 2,2.793 L2,-0.207 C2,-0.75928475 2.44771525,-1.207 3,-1.207 L13,-1.207 Z M13,-0.207 L3,-0.207 L3,2.793 L13,2.793 L13,-0.207 Z M13,9.793 C13.5522847,9.793 14,10.2407153 14,10.793 L14,13.793 C14,14.3452847 13.5522847,14.793 13,14.793 L3,14.793 C2.44771525,14.793 2,14.3452847 2,13.793 L2,10.793 C2,10.2407153 2.44771525,9.793 3,9.793 L13,9.793 Z M13,10.793 L3,10.793 L3,13.793 L13,13.793 L13,10.793 Z"
								transform="translate(8.000000, 6.793000) scale(-1, 1) rotate(-90.000000) translate(-8.000000, -6.793000) "
							/>
						</g>
						<rect fill={color} x="11" y="6" width="2" height="12" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.GAP_ROW:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g transform="translate(12.000000, 12.000000) rotate(90.000000) translate(-12.000000, -12.000000) ">
							<g transform="translate(4.000000, 5.207000)" fill={color}>
								<path
									d="M13,-1.207 C13.5522847,-1.207 14,-0.75928475 14,-0.207 L14,2.793 C14,3.34528475 13.5522847,3.793 13,3.793 L3,3.793 C2.44771525,3.793 2,3.34528475 2,2.793 L2,-0.207 C2,-0.75928475 2.44771525,-1.207 3,-1.207 L13,-1.207 Z M13,-0.207 L3,-0.207 L3,2.793 L13,2.793 L13,-0.207 Z M13,9.793 C13.5522847,9.793 14,10.2407153 14,10.793 L14,13.793 C14,14.3452847 13.5522847,14.793 13,14.793 L3,14.793 C2.44771525,14.793 2,14.3452847 2,13.793 L2,10.793 C2,10.2407153 2.44771525,9.793 3,9.793 L13,9.793 Z M13,10.793 L3,10.793 L3,13.793 L13,13.793 L13,10.793 Z"
									transform="translate(8.000000, 6.793000) scale(-1, 1) rotate(-90.000000) translate(-8.000000, -6.793000) "
								/>
							</g>
							<rect fill={color} x="11" y="6" width="2" height="12" />
						</g>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SHAPE_RECT:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<rect x="0" y="0" width="24" height="24" rx="2" fill="rgba(255, 255, 255, 0.18)" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SHAPE_CIRCLE:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<rect x="0" y="0" width="24" height="24" rx="12" fill="rgba(255, 255, 255, 0.18)" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SHAPE_LINE:
			icon = (
				<svg {...svgProps} viewBox="0 0 56 4">
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<rect x="0" y="0" width="56" height="4" rx="1" fill="rgba(255, 255, 255, 0.18)" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.STRETCH_X:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<polygon fill={color} points="17 13 17 15 20 12 17 9 17 11 7 11 7 9 4 12 7 15 7 13" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.STRETCH_Y:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<polygon fill={color} points="13 7 15 7 12 4 9 7 11 7 11 17 9 17 12 20 15 17 13 17" />
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SQUARED_BTN:
			icon = (
				<svg {...svgProps} width="56" height="24" viewBox="0 0 56 24">
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g transform="translate(-56.000000, -52.000000)" fill="#686868">
							<g transform="translate(56.000000, 52.000000)">
								<rect x="0" y="0" width="56" height="24" rx="2" />
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.ROUNDED_BTN:
			icon = (
				<svg {...svgProps} width="56" height="24" viewBox="0 0 56 24">
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g transform="translate(-128.000000, -52.000000)" fill="#686868">
							<g transform="translate(56.000000, 52.000000)">
								<rect x="72" y="0" width="56" height="24" rx="12" />
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.INPUT_EMAIL:
			icon = (
				<svg {...svgProps}>
					<g fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M13.139,0 L0.86,0 L7,4.384 L13.139,0 Z M14,0.613 L7,5.61288954 L0,0.614 L0,10 L14,10 L14,0.613 Z"
							opacity=".5"
							transform="translate(5 7)"
						/>
						<path
							fill={color}
							d="M19,6 C19.5522847,6 20,6.44771525 20,7 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,7 C4,6.44771525 4.44771525,6 5,6 L19,6 Z M19,7.613 L12,12.6128895 L5,7.614 L5,17 L19,17 L19,7.613 Z M18.139,7 L5.86,7 L12,11.384 L18.139,7 Z"
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.INPUT_TEL:
			icon = (
				<svg {...svgProps}>
					<g fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M2.281,0 L0.002,0 L0.00375344729,0.0837475873 C0.163589521,6.59167709 5.40832291,11.8364105 11.9162524,11.9962466 L12,11.997 L12,9.725 L11.8257738,9.72210693 C11.0342553,9.69056934 10.2519857,9.56473114 9.49660133,9.34833805 L9.262,9.276 L8.65580543,9.87844251 C8.34889793,10.1834504 7.88058025,10.2563391 7.49549289,10.0590328 L7.49549289,10.0590328 L7.49549289,10.0590328 C5.2156426,8.89091165 3.33462657,7.06482439 2.1129525,4.83453974 L1.93467902,4.49699729 L1.9344355,4.4965187 C1.73757583,4.10963477 1.81279759,3.63993018 2.12062997,3.33387114 L2.728,2.73 L2.728,2.73 L2.65678475,2.49570211 C2.44208337,1.74608654 2.3169874,0.96857211 2.28562735,0.175533484 L2.281,0 Z"
							opacity=".5"
							transform="translate(6 6)"
						/>
						<path
							fill={color}
							d="M8.5,5 C8.92777778,5 9.27777778,5.35 9.27777778,5.77777778 C9.27777778,6.75 9.43333333,7.68333333 9.72111111,8.55444444 C9.80666667,8.82666667 9.74444444,9.13 9.52666667,9.34777778 L8.82593472,10.0434962 C9.94593472,12.2446073 11.7503792,14.0412739 13.9514903,15.1690517 L14.6522222,14.4733333 C14.8622222,14.2633333 15.1733333,14.1933333 15.4455556,14.2866667 C16.3166667,14.5744444 17.2577778,14.73 18.2222222,14.73 C18.65,14.73 19,15.08 19,15.5077778 L19,18.2222222 C19,18.65 18.65,19 18.2222222,19 C10.9188889,19 5,13.0811111 5,5.77777778 C5,5.35 5.35,5 5.77777778,5 L8.5,5 Z M8.281,6 L6.002,6 L6.00375345,6.08374759 C6.16358952,12.5916771 11.4083229,17.8364105 17.9162524,17.9962466 L18,17.997 L18,15.725 L17.8257738,15.7221069 C17.0342553,15.6905693 16.2519857,15.5647311 15.4966013,15.3483381 L15.262,15.276 L14.6558054,15.8784425 C14.3488979,16.1834504 13.8805802,16.2563391 13.4954929,16.0590328 L13.4954929,16.0590328 L13.4954929,16.0590328 C11.2156426,14.8909116 9.33462657,13.0648244 8.1129525,10.8345397 L7.93467902,10.4969973 L7.9344355,10.4965187 C7.73757583,10.1096348 7.81279759,9.63993018 8.12062997,9.33387114 L8.728,8.73 L8.728,8.73 L8.65678475,8.49570211 C8.44208337,7.74608654 8.3169874,6.96857211 8.28562735,6.17553348 L8.281,6 Z"
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SHARE_EMAIL:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M19,6 C19.5522847,6 20,6.44771525 20,7 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,7 C4,6.44771525 4.44771525,6 5,6 L19,6 Z M19,7.613 L12,12.6128895 L5,7.614 L5,17 L19,17 L19,7.613 Z M18.139,7 L5.86,7 L12,11.384 L18.139,7 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SHARE_FB:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M13.4570256,20 L13.4570256,12.8 L15.6429544,12.8 L16,9.6 L13.4570256,9.6 L13.4570256,8.0416 C13.4570256,7.2176 13.4780744,6.4 14.6295072,6.4 L15.7957512,6.4 L15.7957512,4.112 C15.7957512,4.0776 14.7939976,4 13.7805496,4 C11.6640032,4 10.3387256,5.3256 10.3387256,7.76 L10.3387256,9.6 L8,9.6 L8,12.8 L10.3387256,12.8 L10.3387256,20 L13.4570256,20 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SHARE_WA:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M20,11.5692308 C19.8769231,7.38461538 16.3692308,4 12.1230769,4 C7.87692308,4 4.43076923,7.32307692 4.24615385,11.4461538 C4.24615385,11.5692308 4.24615385,11.6923077 4.24615385,11.8153846 C4.24615385,13.2923077 4.67692308,14.6461538 5.35384615,15.8153846 L4,20 L8.30769231,18.6461538 C9.41538462,19.2615385 10.7076923,19.6307692 12.1230769,19.6307692 C16.4923077,19.6307692 20,16.1230769 20,11.8153846 C20,11.7538462 20,11.6923077 20,11.5692308 Z M12.1230769,18.3384615 C10.7692308,18.3384615 9.53846154,17.9692308 8.49230769,17.2307692 L5.96923077,18.0307692 L6.76923077,15.5692308 C5.96923077,14.4615385 5.53846154,13.1692308 5.53846154,11.7538462 C5.53846154,11.5692308 5.53846154,11.3230769 5.6,11.1384615 C5.84615385,7.81538462 8.67692308,5.23076923 12.1230769,5.23076923 C15.5692308,5.23076923 18.4615385,7.87692308 18.7076923,11.2615385 C18.7076923,11.4461538 18.7076923,11.6307692 18.7076923,11.7538462 C18.7076923,15.3846154 15.7538462,18.3384615 12.1230769,18.3384615 Z"
							fill={color}
						/>
						<path
							d="M15.5863213,12.8758872 C15.3982307,12.7566889 14.3950807,12.339495 14.269687,12.2798959 C14.0815964,12.2202968 13.9562027,12.1606977 13.8308089,12.3990942 C13.7054152,12.5778916 13.329234,12.9950854 13.2038402,13.1142837 C13.0784465,13.2334819 12.9530527,13.2334819 12.7649621,13.1738828 C12.5768715,13.0546846 11.9499028,12.8758872 11.1975404,12.2798959 C10.6332685,11.8031029 10.1943905,11.2071117 10.1316936,11.0283143 C10.0062998,10.8495169 10.1316936,10.7303187 10.1943905,10.6707195 C10.2570873,10.6111204 10.3824811,10.432323 10.5078748,10.3727239 C10.5078748,10.3131248 10.5705717,10.3131248 10.5705717,10.3131248 C10.6332685,10.2535257 10.6332685,10.1939265 10.6959654,10.0747283 C10.7586623,9.95553004 10.7586623,9.83633179 10.6959654,9.77673266 C10.6332685,9.65753441 10.2570873,8.76354754 10.0689967,8.40595278 C9.8809061,8.04835803 9.75551236,8.10795716 9.63011862,8.10795716 C9.50472488,8.10795716 9.37933114,8.10795716 9.2539374,8.10795716 C9.06584679,7.92915978 8.87775618,7.98875891 8.68966557,8.16755628 C8.50157496,8.34635366 8,8.76354754 8,9.71713354 C8,9.95553004 8.06269687,10.1343274 8.12539374,10.3727239 C8.31348435,11.0283143 8.75236244,11.5647064 8.81505931,11.6839047 C8.94045305,11.8031029 10.1943905,13.7102749 12.1379934,14.4850636 C14.1442933,15.2002531 14.1442933,14.9618566 14.5204745,14.9618566 C14.8966557,14.9618566 15.711715,14.5446627 15.8371088,14.0678697 C16.0251994,13.6506758 16.0251994,13.2930811 15.9625025,13.1738828 C15.8998056,13.0546846 15.7744119,12.9950854 15.5863213,12.8758872 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SHARE_TW:
			icon = (
				<svg {...svgProps}>
					<path
						d="M9.032,18.7999997 C15.0696,18.7999997 18.372,13.8749197 18.372,9.60436768 C18.372,9.46416768 18.372,9.32475968 18.3624,9.18613568 C19.0048,8.72930368 19.5592,8.16220768 20,7.51319968 C19.4016,7.77469568 18.7656,7.94639968 18.1152,8.02200768 C18.8,7.61795168 19.3128,6.98311968 19.5584,6.23407968 C18.9136,6.61056768 18.2088,6.87599968 17.4736,7.01856768 C16.2304,5.71739168 14.1512,5.65438368 12.8288,6.87836768 C11.9768,7.66757568 11.6144,8.84430368 11.8792,9.96667968 C9.24,9.83593568 6.7808,8.60879968 5.1136,6.59009568 C4.2424,8.06690368 4.688,9.95565568 6.1304,10.9039677 C5.608,10.8889997 5.0968,10.7503757 4.64,10.4999117 L4.64,10.5408637 C4.6408,12.0791197 5.7424,13.4039197 7.2736,13.7087277 C6.7904,13.8386877 6.2832,13.8575917 5.792,13.7638637 C6.2216,15.0807917 7.4544,15.9826317 8.8584,16.0086237 C7.696,16.9081037 6.26,17.3964317 4.7816,17.3948637 C4.5208,17.3940717 4.26,17.3791037 4,17.3483917 C5.5016,18.2967037 7.248,18.7999997 9.032,18.7976397"
						fill={color}
						fillRule="nonzero"
					/>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.TIMER_NUM:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M20,7 C20.5522847,7 21,7.44771525 21,8 L21,16 C21,16.5522847 20.5522847,17 20,17 L4,17 C3.44771525,17 3,16.5522847 3,16 L3,8 C3,7.44771525 3.44771525,7 4,7 L20,7 Z M20,8 L4,8 L4,16 L20,16 L20,8 Z"
							fill={color}
						/>
						<path
							d="M11.7500172,13.5 C11.6121432,13.5 11.4939654,13.4583062 11.395484,13.3749186 C11.2970025,13.2915309 11.2485193,13.1899023 11.2500344,13.0700326 C11.2485193,12.9527687 11.2970025,12.852443 11.395484,12.7690554 C11.4939654,12.6856678 11.6121432,12.6439739 11.7500172,12.6439739 C11.883346,12.6439739 11.9996298,12.6856678 12.0988688,12.7690554 C12.1981078,12.852443 12.2484849,12.9527687 12.25,13.0700326 C12.2484849,13.1495114 12.2246221,13.2218241 12.1784116,13.2869707 C12.132201,13.3521173 12.0715971,13.4039088 11.9965996,13.4423453 C11.9216022,13.4807818 11.8394081,13.5 11.7500172,13.5 Z M11.7500172,11.3560261 C11.6121432,11.3560261 11.4939654,11.3143322 11.395484,11.2309446 C11.2970025,11.147557 11.2485193,11.0459283 11.2500344,10.9260586 C11.2485193,10.8087948 11.2970025,10.7084691 11.395484,10.6250814 C11.4939654,10.5416938 11.6121432,10.5 11.7500172,10.5 C11.883346,10.5 11.9996298,10.5416938 12.0988688,10.6250814 C12.1981078,10.7084691 12.2484849,10.8087948 12.25,10.9260586 C12.2484849,11.0055375 12.2246221,11.0778502 12.1784116,11.1429967 C12.132201,11.2081433 12.0715971,11.2599349 11.9965996,11.2983713 C11.9216022,11.3368078 11.8394081,11.3560261 11.7500172,11.3560261 Z"
							fillOpacity="0.99"
							fill={color}
							fillRule="nonzero"
						/>
						<path
							d="M6.66725852,13.8192472 C6.37488163,13.8192472 6.12423059,13.7449692 5.9153054,13.5964134 C5.70638021,13.4478575 5.54598722,13.2330137 5.43412642,12.9518821 C5.32226563,12.6707505 5.26633523,12.3319129 5.26633523,11.9353693 C5.26751894,11.5388258 5.32404119,11.2011719 5.43590199,10.9224077 C5.54776278,10.6436435 5.70815578,10.4308712 5.91708097,10.2840909 C6.12600616,10.1373106 6.37606534,10.0639205 6.66725852,10.0639205 C6.9584517,10.0639205 7.20880682,10.1373106 7.41832386,10.2840909 C7.62784091,10.4308712 7.78852983,10.6439394 7.90039063,10.9232955 C8.01225142,11.2026515 8.06818182,11.5400095 8.06818182,11.9353693 C8.06818182,12.3330966 8.01225142,12.672526 7.90039063,12.9536577 C7.78852983,13.2347893 7.62813684,13.4493371 7.41921165,13.5973011 C7.21028646,13.7452652 6.95963542,13.8192472 6.66725852,13.8192472 Z M6.66725852,13.2634943 C6.89453125,13.2634943 7.07415956,13.1513376 7.20614347,12.9270241 C7.33812737,12.7027107 7.40411932,12.3721591 7.40411932,11.9353693 C7.40411932,11.6465436 7.37393466,11.4038826 7.31356534,11.2073864 C7.25319602,11.0108902 7.16796875,10.8626302 7.05788352,10.7626065 C6.9477983,10.6625829 6.81758996,10.612571 6.66725852,10.612571 C6.44116951,10.612571 6.26242898,10.7247277 6.13103693,10.9490412 C5.99964489,11.1733546 5.93335701,11.5021307 5.9321733,11.9353693 C5.93098958,12.2253788 5.96028646,12.4692235 6.02006392,12.6669034 C6.07984138,12.8645833 6.16477273,13.0134351 6.27485795,13.1134588 C6.38494318,13.2134825 6.51574337,13.2634943 6.66725852,13.2634943 Z"
							fillOpacity="0.99"
							fill={color}
							fillRule="nonzero"
						/>
						<polygon
							fillOpacity="0.99"
							fill={color}
							fillRule="nonzero"
							points="10.117488 10.1136364 10.117488 13.75 9.45875219 13.75 9.45875219 10.7546165 9.43744537 10.7546165 8.58694821 11.2979403 8.58694821 10.6942472 9.49071241 10.1136364"
						/>
						<path
							d="M14.1672585,13.8192472 C13.8748816,13.8192472 13.6242306,13.7449692 13.4153054,13.5964134 C13.2063802,13.4478575 13.0459872,13.2330137 12.9341264,12.9518821 C12.8222656,12.6707505 12.7663352,12.3319129 12.7663352,11.9353693 C12.7675189,11.5388258 12.8240412,11.2011719 12.935902,10.9224077 C13.0477628,10.6436435 13.2081558,10.4308712 13.417081,10.2840909 C13.6260062,10.1373106 13.8760653,10.0639205 14.1672585,10.0639205 C14.4584517,10.0639205 14.7088068,10.1373106 14.9183239,10.2840909 C15.1278409,10.4308712 15.2885298,10.6439394 15.4003906,10.9232955 C15.5122514,11.2026515 15.5681818,11.5400095 15.5681818,11.9353693 C15.5681818,12.3330966 15.5122514,12.672526 15.4003906,12.9536577 C15.2885298,13.2347893 15.1281368,13.4493371 14.9192116,13.5973011 C14.7102865,13.7452652 14.4596354,13.8192472 14.1672585,13.8192472 Z M14.1672585,13.2634943 C14.3945313,13.2634943 14.5741596,13.1513376 14.7061435,12.9270241 C14.8381274,12.7027107 14.9041193,12.3721591 14.9041193,11.9353693 C14.9041193,11.6465436 14.8739347,11.4038826 14.8135653,11.2073864 C14.753196,11.0108902 14.6679688,10.8626302 14.5578835,10.7626065 C14.4477983,10.6625829 14.31759,10.612571 14.1672585,10.612571 C13.9411695,10.612571 13.762429,10.7247277 13.6310369,10.9490412 C13.4996449,11.1733546 13.433357,11.5021307 13.4321733,11.9353693 C13.4309896,12.2253788 13.4602865,12.4692235 13.5200639,12.6669034 C13.5798414,12.8645833 13.6647727,13.0134351 13.774858,13.1134588 C13.8849432,13.2134825 14.0157434,13.2634943 14.1672585,13.2634943 Z"
							fillOpacity="0.99"
							fill={color}
							fillRule="nonzero"
						/>
						<path
							d="M17.4825448,13.8192472 C17.1901679,13.8192472 16.9395169,13.7449692 16.7305917,13.5964134 C16.5216665,13.4478575 16.3612735,13.2330137 16.2494127,12.9518821 C16.1375519,12.6707505 16.0816215,12.3319129 16.0816215,11.9353693 C16.0828052,11.5388258 16.1393275,11.2011719 16.2511883,10.9224077 C16.3630491,10.6436435 16.5234421,10.4308712 16.7323672,10.2840909 C16.9412924,10.1373106 17.1913516,10.0639205 17.4825448,10.0639205 C17.773738,10.0639205 18.0240931,10.1373106 18.2336101,10.2840909 C18.4431272,10.4308712 18.6038161,10.6439394 18.7156769,10.9232955 C18.8275377,11.2026515 18.8834681,11.5400095 18.8834681,11.9353693 C18.8834681,12.3330966 18.8275377,12.672526 18.7156769,12.9536577 C18.6038161,13.2347893 18.4434231,13.4493371 18.2344979,13.5973011 C18.0255727,13.7452652 17.7749217,13.8192472 17.4825448,13.8192472 Z M17.4825448,13.2634943 C17.7098175,13.2634943 17.8894458,13.1513376 18.0214297,12.9270241 C18.1534136,12.7027107 18.2194056,12.3721591 18.2194056,11.9353693 C18.2194056,11.6465436 18.1892209,11.4038826 18.1288516,11.2073864 C18.0684823,11.0108902 17.983255,10.8626302 17.8731698,10.7626065 C17.7630846,10.6625829 17.6328762,10.612571 17.4825448,10.612571 C17.2564558,10.612571 17.0777153,10.7247277 16.9463232,10.9490412 C16.8149312,11.1733546 16.7486433,11.5021307 16.7474596,11.9353693 C16.7462759,12.2253788 16.7755727,12.4692235 16.8353502,12.6669034 C16.8951277,12.8645833 16.980059,13.0134351 17.0901442,13.1134588 C17.2002295,13.2134825 17.3310296,13.2634943 17.4825448,13.2634943 Z"
							fillOpacity="0.99"
							fill={color}
							fillRule="nonzero"
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.TIMER_BAR:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(4.000000, 9.000000)" fill={color}>
							<path d="M0,3 C2.02906125e-16,4.65685425 1.34314575,6 3,6 L8,6 L8,6 L8,0 L3,0 C1.34314575,3.04359188e-16 -2.02906125e-16,1.34314575 0,3 Z" />
						</g>
						<path
							d="M17,8 C19.209139,8 21,9.790861 21,12 C21,14.209139 19.209139,16 17,16 L17,16 L7,16 C4.790861,16 3,14.209139 3,12 C3,9.790861 4.790861,8 7,8 L7,8 Z M17,9 L7,9 C5.34314575,9 4,10.3431458 4,12 C4,13.6568542 5.34314575,15 7,15 L17,15 C18.6568542,15 20,13.6568542 20,12 C20,10.3431458 18.6568542,9 17,9 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.TIMER_CIRC:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.499976749" transform="translate(5.817000, 5.986000)" fill={color}>
							<path d="M6.183,0.014 L6.183,3.014 L6.183,3.014 C4.52614575,3.014 3.183,4.35714575 3.183,6.014 C3.183,7.67085425 4.52614575,9.014 6.183,9.014 C7.01142712,9.014 7.76142712,8.67821356 8.30432034,8.13532034 L10.4256407,10.2566407 C9.33985425,11.3424271 7.83985425,12.014 6.183,12.014 C2.8692915,12.014 0.183,9.3277085 0.183,6.014 C0.183,2.7002915 2.8692915,0.014 6.183,0.014 L6.183,0.014 Z" />
						</g>
						<path
							d="M12,5 C15.8659932,5 19,8.13400675 19,12 C19,15.8659932 15.8659932,19 12,19 C8.13400675,19 5,15.8659932 5,12 C5,8.13400675 8.13400675,5 12,5 Z M12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 Z M12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 Z M12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.INPUT_TEXT:
		case LAYER_ICONS[TYPE.TEXT]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M5.07573023,17 L6.17303032,13.9105143 L10.5835375,13.9105143 L11.6808376,17 L13.0657794,17 L9.06010143,6.09091949 L7.69646637,6.09091949 L3.69078837,17 L5.07573023,17 Z M10.1680549,12.7386404 L6.58851288,12.7386404 L8.3356703,7.81677012 L8.42089749,7.81677012 L10.1680549,12.7386404 Z M16.1998546,17.1917612 C17.62741,17.1917612 18.3731479,16.4247165 18.6288295,15.8920465 L18.6927499,15.8920465 L18.6927499,17 L19.949851,17 L19.949851,11.6093801 C19.949851,9.0099508 17.9683188,8.71165563 16.9242857,8.71165563 C15.6884914,8.71165563 14.2822428,9.13779159 13.6430388,10.6292674 L14.8362195,11.0554034 C15.1132079,10.4588131 15.7683919,9.81960912 16.9668993,9.81960912 C18.1227931,9.81960912 18.6927499,10.4321796 18.6927499,11.4815394 L18.6927499,11.5241529 C18.6927499,12.1313967 18.0748528,12.0781297 16.5833769,12.2698909 C15.0652676,12.4669788 13.408664,12.8025608 13.408664,14.677559 C13.408664,16.2755689 14.6444583,17.1917612 16.1998546,17.1917612 Z M16.3916157,16.0625009 C15.3901962,16.0625009 14.6657651,15.6150581 14.6657651,14.7414794 C14.6657651,13.7826735 15.5393438,13.4843784 16.5194565,13.3565376 C17.0521265,13.2926172 18.4796819,13.1434696 18.6927499,12.887788 L18.6927499,14.0383551 C18.6927499,15.0610814 17.8830916,16.0625009 16.3916157,16.0625009 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.IMG]:
		case PROP_FIELD_ICONS.BACKGROUND:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(5.000000, 11.207000)" fill={color}>
							<polygon
								className="fill"
								points="4.729 -3.55271368e-15 6.03961325e-14 4.729 6.03961325e-14 5.793 13.264 5.793 10.83 3.359 9.45902184 4.7296177"
							/>
						</g>
						<path
							d="M19,6 C19.5522847,6 20,6.44771525 20,7 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,7 C4,6.44771525 4.44771525,6 5,6 L19,6 Z M9.729,11.207 L5,15.936 L5,17 L18.264,17 L15.83,14.566 L14.4590218,15.9366177 L9.729,11.207 Z M19,7 L5,7 L5,14.521 L9.72951092,9.79289322 L14.459,14.522 L15.8297428,13.1516832 L19,16.322 L19,7 Z M16,8 C17.1045695,8 18,8.8954305 18,10 C18,11.1045695 17.1045695,12 16,12 C14.8954305,12 14,11.1045695 14,10 C14,8.8954305 14.8954305,8 16,8 Z M16,9 C15.4477153,9 15,9.44771525 15,10 C15,10.5522847 15.4477153,11 16,11 C16.5522847,11 17,10.5522847 17,10 C17,9.44771525 16.5522847,9 16,9 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.VIDEO]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M19,6.06315789 C19.5522847,6.06315789 20,6.51558594 20,7.07368421 L20,17.1789474 C20,17.7370456 19.5522847,18.1894737 19,18.1894737 L5,18.1894737 C4.44771525,18.1894737 4,17.7370456 4,17.1789474 L4,7.07368421 C4,6.51558594 4.44771525,6.06315789 5,6.06315789 L19,6.06315789 Z M19,7.07368421 L5,7.07368421 L5,17.1789474 L19,17.1789474 L19,7.07368421 Z M9.75,15.6268816 L15.75,12.1263158 L9.75,8.62574995 L9.75,15.6268816 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.TIMER]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.499976749" transform="translate(6.817000, 4.986000)" fill={color}>
							<path d="M10.183,0.0141983643 L10.1766127,1.99325899 C10.10449,3.20704329 9.42612526,4.30466056 8.37273781,4.91198988 L8.183,5.014 L7.07742719,5.5667864 L6.94467599,5.64113389 C6.4739572,5.9346113 6.183,6.45220611 6.183,7.014 L4.183,7.014 C4.183,6.45220611 3.8920428,5.9346113 3.42132401,5.64113389 L3.28857281,5.5667864 L2.183,5.014 C1.02178009,4.43339004 0.265752475,3.27844237 0.189387296,1.99325899 L0.183,0.0139999999 L10.183,0.0141983643 Z" />
						</g>
						<path
							d="M15.2064177,4 L8.76393202,4 C7.23745452,4 6,5.23745452 6,6.76393202 L6,6.76393202 L6,6.76393202 L6.00682696,7.00890919 C6.10591887,8.6840036 7.07485654,10.1554623 8.5527864,10.8944272 L9.65835921,11.4472136 L9.74968655,11.4996208 C9.88962374,11.5881666 10,11.7863952 10,12 C10,12.234094 9.86773926,12.4480964 9.65835921,12.5527864 L8.5527864,13.1055728 L8.33672527,13.2212361 C6.88279054,14.0589916 6,15.5836922 6,17.236068 C6,18.7625455 7.23745452,20 8.76393202,20 L15.236068,20 C16.7625455,20 18,18.7625455 18,17.236068 L18,17.236068 L18,17.236068 L17.993173,16.9910908 C17.8997783,15.4118764 17.0339997,14.0110171 15.689217,13.2356842 L15.4735369,13.119226 L14.3416408,12.5527864 L14.2503134,12.5003792 C14.1103763,12.4118334 14,12.2136048 14,12 C14,11.7863952 14.1103763,11.5881666 14.2907389,11.4757165 L14.3830647,11.4252733 L15.4472136,10.8944272 L15.6632747,10.7787639 C17.0339997,9.98898287 17.8997783,8.58812364 17.991852,7.03857404 L17.9995603,6.79358222 C17.9998031,5.25097216 16.7494674,4.00024282 15.2068573,4.00000003 C15.2067108,4.00000001 15.2065643,4 15.2064177,4 Z M17,5 L17,6.76393202 L16.9936127,6.97925899 C16.92149,8.19304329 16.2431253,9.29066056 15.1897378,9.89798988 L15,10 L13.8944272,10.5527864 L13.761676,10.6271339 C13.2909572,10.9206113 13,11.4382061 13,12 C13,12.5617939 13.2909572,13.0793887 13.761676,13.3728661 L13.8944272,13.4472136 L15,14 L15.1897378,14.1020101 C16.2431253,14.7093394 16.92149,15.8069567 16.9936127,17.020741 L17,17.236068 L17,19 L7,19 L7,17.236068 C7,15.9377846 7.69491078,14.7450647 8.81026219,14.1020101 L9,14 L10.1055728,13.4472136 C10.6537369,13.1731316 11,12.6128661 11,12 C11,11.4382061 10.7090428,10.9206113 10.238324,10.6271339 L10.1055728,10.5527864 L9,10 C7.83878009,9.41939004 7.08275247,8.26444237 7.0063873,6.97925899 L7,6.76393202 L7,5 L17,5 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.BUTTON]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(4.000000, 9.000000)" fill={color}>
							<path d="M0,3 C2.02906125e-16,4.65685425 1.34314575,6 3,6 L13,6 C14.6568542,6 16,4.65685425 16,3 C16,1.34314575 14.6568542,-3.04359188e-16 13,0 L3,0 C1.34314575,3.04359188e-16 -2.02906125e-16,1.34314575 0,3 Z" />
						</g>
						<path
							d="M17,8 C19.209139,8 21,9.790861 21,12 C21,14.209139 19.209139,16 17,16 L17,16 L7,16 C4.790861,16 3,14.209139 3,12 C3,9.790861 4.790861,8 7,8 L7,8 Z M17,9 L7,9 C5.34314575,9 4,10.3431458 4,12 C4,13.6568542 5.34314575,15 7,15 L17,15 C18.6568542,15 20,13.6568542 20,12 C20,10.3431458 18.6568542,9 17,9 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.ANSWER]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(6.000000, 6.000000)" />
						<path
							d="M11,18 L11,19 L9,19 L9,18 L11,18 Z M6,17 L6,18 L7,18 L7,19 L6,19 C5.44771525,19 5,18.5522847 5,18 L5,17 L6,17 Z M15,18 L15,19 L13,19 L13,18 L15,18 Z M19,17 L19,18 C19,18.5522847 18.5522847,19 18,19 L17,19 L17,18 L18,18 L18,17 L19,17 Z M19,13 L19,15 L18,15 L18,13 L19,13 Z M19,9 L19,11 L18,11 L18,9 L19,9 Z M6,9 L6,11 L5,11 L5,9 L6,9 Z M18,5 C18.5522847,5 19,5.44771525 19,6 L19,7 L18,7 L18,6 L17,6 L17,5 L18,5 Z M7,5 L7,6 L6,6 L6,7 L5,7 L5,6 C5,5.44771525 5.44771525,5 6,5 L7,5 Z M11,5 L11,6 L9,6 L9,5 L11,5 Z M15,5 L15,6 L13,6 L13,5 L15,5 Z M5,13 L6,13 L6,15 L5,15 L5,13 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.BOX]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(5.000000, 5.207000)" />
						<path
							d="M19,5 C19.5522847,5 20,5.44771525 20,6 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,6 C4,5.44771525 4.44771525,5 5,5 L19,5 Z M19,6 L5,6 L5,17 L19,17 L19,6 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.TEXT_FIELD]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<rect width="8" height="2" fill={color} opacity=".5" transform="translate(6 11)" />
						<path
							fill={color}
							d="M20,8 C20.5522847,8 21,8.44771525 21,9 L21,9 L21,15 C21,15.5522847 20.5522847,16 20,16 L20,16 L4,16 C3.44771525,16 3,15.5522847 3,15 L3,15 L3,9 C3,8.44771525 3.44771525,8 4,8 L4,8 Z M20,9 L4,9 L4,15 L20,15 L20,9 Z"
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.TEXT_AREA_FIELD]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M8,3 L8,5 L0,5 L0,3 L8,3 Z M12,0 L12,2 L0,2 L0,0 L12,0 Z"
							opacity=".5"
							transform="translate(6 8)"
						/>
						<path
							fill={color}
							d="M20,5 C20.5522847,5 21,5.44771525 21,6 L21,6 L21,18 C21,18.5522847 20.5522847,19 20,19 L20,19 L4,19 C3.44771525,19 3,18.5522847 3,18 L3,18 L3,6 C3,5.44771525 3.44771525,5 4,5 L4,5 Z M20,6 L4,6 L4,18 L20,18 L20,6 Z"
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.CHECKBOX]:
			icon = (
				<svg {...svgProps} viewBox="0 0 96 96">
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(24.000000, 44.000000)" fill={color}>
							<path d="M56,0 L56,8 L20,8 L20,0 L56,0 Z M8,0 L8,8 L0,8 L0,0 L8,0 Z" />
						</g>
						<path
							d="M36,36 C38.209139,36 40,37.790861 40,40 L40,40 L40,56 C40,58.209139 38.209139,60 36,60 L36,60 L20,60 C17.790861,60 16,58.209139 16,56 L16,56 L16,40 C16,37.790861 17.790861,36 20,36 L20,36 Z M36,40 L20,40 L20,56 L36,56 L36,40 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.SHAPE]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M10.433,8.764 C11.5375695,8.764 12.433,9.6594305 12.433,10.764 C12.433,11.8685695 11.5375695,12.764 10.433,12.764 C9.3284305,12.764 8.433,11.8685695 8.433,10.764 C8.433,9.6594305 9.3284305,8.764 10.433,8.764 Z M4.433,0.764 L4.433,4.764 L0.433,4.764 L0.433,0.764 L4.433,0.764 Z"
							opacity=".5"
							transform="translate(5.567 5.236)"
						/>
						<path
							fill={color}
							d="M16,13 C17.6568542,13 19,14.3431458 19,16 C19,17.6568542 17.6568542,19 16,19 C14.3431458,19 13,17.6568542 13,16 C13,14.3431458 14.3431458,13 16,13 Z M18.0459415,5.74695167 L18.7530483,6.45405845 L6.73223305,18.4748737 L6.02512627,17.767767 L18.0459415,5.74695167 Z M16,14 C14.8954305,14 14,14.8954305 14,16 C14,17.1045695 14.8954305,18 16,18 C17.1045695,18 18,17.1045695 18,16 C18,14.8954305 17.1045695,14 16,14 Z M10,5 C10.5522847,5 11,5.44771525 11,6 L11,10 C11,10.5522847 10.5522847,11 10,11 L6,11 C5.44771525,11 5,10.5522847 5,10 L5,6 C5,5.44771525 5.44771525,5 6,5 L10,5 Z M10,6 L6,6 L6,10 L10,10 L10,6 Z"
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS[TYPE.EMBED]:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M19,5 C19.5522847,5 20,5.44771525 20,6 L20,17 C20,17.5522847 19.5522847,18 19,18 L5,18 C4.44771525,18 4,17.5522847 4,17 L4,6 C4,5.44771525 4.44771525,5 5,5 L19,5 Z M19,6 L5,6 L5,17 L19,17 L19,6 Z M13.4671068,8.96446609 L16.0026407,11.5 L13.4671068,14.0355339 L12.76,13.3284271 L14.5891342,11.4992929 L12.76,9.67157288 L13.4671068,8.96446609 Z M10.5355339,8.96446609 L11.2426407,9.67157288 L9.41350646,11.4992929 L11.2426407,13.3284271 L10.5355339,14.0355339 L8,11.5 L10.5355339,8.96446609 Z"
						/>
					</g>
				</svg>
			);
			break;
		case PROP_FIELD_ICONS.SYMBOL:
		case LAYER_ICONS.SYMBOL:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M6.433,0.764 L3.433,0.764 L3.433,4.764 L1.433,4.764 C0.88071525,4.764 0.433,5.21171525 0.433,5.764 C0.433,6.31628475 0.88071525,6.764 1.433,6.764 L3.433,6.764 L3.433,10.764 L6.433,10.764 L6.433,9.764 C6.433,8.6594305 7.3284305,7.764 8.433,7.764 C9.5375695,7.764 10.433,8.6594305 10.433,9.764 L10.433,10.764 L13.433,10.764 L13.433,6.764 L15.433,6.764 C15.9852847,6.764 16.433,6.31628475 16.433,5.764 C16.433,5.25116416 16.0469598,4.82849284 15.5496211,4.77072773 L15.433,4.764 L13.433,4.764 L13.433,0.764 L10.433,0.764 L10.433,1.764 C10.433,2.8183618 9.61712221,3.68216512 8.58226234,3.75851426 L8.433,3.764 C7.3786382,3.764 6.51483488,2.94812221 6.43848574,1.91326234 L6.433,1.764 L6.433,0.764 Z"
							opacity=".5"
							transform="translate(3.567 6.236)"
						/>
						<path
							fill={color}
							d="M11,6 L11,8 C11,8.55228475 11.4477153,9 12,9 C12.5522847,9 13,8.55228475 13,8 L13,6 L17,6 C17.5522847,6 18,6.44771525 18,7 L18,10 L19,10 C20.1045695,10 21,10.8954305 21,12 C21,13.1045695 20.1045695,14 19,14 L18,14 L18,17 C18,17.5522847 17.5522847,18 17,18 L13,18 L13,16 C13,15.4477153 12.5522847,15 12,15 C11.4871642,15 11.0644928,15.3860402 11.0067277,15.8833789 L11,16 L11,18 L7,18 C6.44771525,18 6,17.5522847 6,17 L6,14 L5,14 C3.9456382,14 3.08183488,13.1841222 3.00548574,12.1492623 L3,12 C3,10.9456382 3.81587779,10.0818349 4.85073766,10.0054857 L5,10 L6,10 L6,7 C6,6.44771525 6.44771525,6 7,6 L11,6 Z M10,7 L7,7 L7,11 L5,11 C4.44771525,11 4,11.4477153 4,12 C4,12.5522847 4.44771525,13 5,13 L7,13 L7,17 L10,17 L10,16 C10,14.8954305 10.8954305,14 12,14 C13.1045695,14 14,14.8954305 14,16 L14,17 L17,17 L17,13 L19,13 C19.5522847,13 20,12.5522847 20,12 C20,11.4871642 19.6139598,11.0644928 19.1166211,11.0067277 L19,11 L17,11 L17,7 L14,7 L14,8 C14,9.0543618 13.1841222,9.91816512 12.1492623,9.99451426 L12,10 C10.9456382,10 10.0818349,9.18412221 10.0054857,8.14926234 L10,8 L10,7 Z"
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS.SHARE:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M17,8.8 C18.3254834,8.8 19.4,7.7254834 19.4,6.4 C19.4,5.0745166 18.3254834,4 17,4 C15.6745166,4 14.6,5.0745166 14.6,6.4 C14.6,7.7254834 15.6745166,8.8 17,8.8 Z"
							stroke={color}
							className="stroke"
						/>
						<path
							d="M7.4,14.4 C8.7254834,14.4 9.8,13.3254834 9.8,12 C9.8,10.6745166 8.7254834,9.6 7.4,9.6 C6.0745166,9.6 5,10.6745166 5,12 C5,13.3254834 6.0745166,14.4 7.4,14.4 Z"
							stroke={color}
							className="stroke"
						/>
						<path
							d="M17,20 C18.3254834,20 19.4,18.9254834 19.4,17.6 C19.4,16.2745166 18.3254834,15.2 17,15.2 C15.6745166,15.2 14.6,16.2745166 14.6,17.6 C14.6,18.9254834 15.6745166,20 17,20 Z"
							stroke={color}
							className="stroke"
						/>
						<path className="stroke" d="M9.472,13.208 L14.936,16.392 L9.472,13.208 Z" stroke={color} />
						<path className="stroke" d="M14.928,7.608 L9.472,10.792 L14.928,7.608 Z" stroke={color} />
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS.LOCKED:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<polygon fill={color} points="10 8 10 0 0 0 0 8" opacity=".5" transform="translate(7 11)" />
						<path
							fill={color}
							d="M17,10 C17.5522847,10 18,10.4477153 18,11 L18,19 C18,19.5522847 17.5522847,20 17,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,11 C6,10.4477153 6.44771525,10 7,10 L8,10 L8,8 C8,5.790861 9.790861,4 12,4 C14.209139,4 16,5.790861 16,8 L16,10 L17,10 Z M17,11 L7,11 L7,19 L17,19 L17,11 Z M15,8 C15,6.34314575 13.6568542,5 12,5 C10.4023191,5 9.09633912,6.24891996 9.00509269,7.82372721 L9,8 L9,10 L15,10 L15,8 Z"
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS.UNLOCKED:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<polygon fill={color} points="10 8 10 0 0 0 0 8" opacity=".5" transform="translate(7 11)" />
						<path
							fill={color}
							d="M17,10 C17.5522847,10 18,10.4477153 18,11 L18,19 C18,19.5522847 17.5522847,20 17,20 L7,20 C6.44771525,20 6,19.5522847 6,19 L6,11 C6,10.4477153 6.44771525,10 7,10 L8,10 L8,8 C8,5.790861 9.790861,4 12,4 C13.4801068,4 14.7724528,4.80389977 15.4642293,5.99889078 L14.2353163,5.99911749 C13.6860206,5.3858804 12.8880739,5 12,5 C10.4023191,5 9.09633912,6.24891996 9.00509269,7.82372721 L9,8 L9,10 L17,10 Z M17,11 L7,11 L7,19 L17,19 L17,11 Z"
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS.HIDDEN:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M6.86179041,2.52544518 C6.95175371,2.83495715 7,3.16198519 7,3.5 C7,5.42888889 5.42888889,7 3.5,7 C3.16198519,7 2.83495715,6.95175371 2.52544518,6.86179041 Z M3.5,0 C4.35192593,0 5.13406034,0.306475772 5.74186769,0.814891767 L0.814891767,5.74186769 C0.306475772,5.13406034 0,4.35192593 0,3.5 C0,1.57111111 1.57111111,0 3.5,0 Z"
							opacity=".5"
							transform="translate(8.5 8.5)"
						/>
						<path
							fill={color}
							d="M19.5563492,4 L20.263456,4.70710678 L4.70710678,20.263456 L4,19.5563492 L6.50186982,17.0561585 C4.4731372,15.8994945 2.87730855,14.1223429 2,12 C3.57272727,8.19533333 7.45454545,5.5 12,5.5 C13.7735505,5.5 15.4460681,5.91034104 16.9198101,6.63681207 L19.5563492,4 Z M22,12 C20.4272727,15.8046667 16.5454545,18.5 12,18.5 C10.7580766,18.5 9.56569431,18.298791 8.45641429,17.9287216 L9.25739064,17.1268921 C10.0381459,17.3443964 10.8564412,17.4710043 11.6972531,17.4955798 L12,17.5 C15.8463915,17.5 19.2644829,15.3632448 20.8422266,12.136393 L20.906,11.999 L20.8422266,11.863607 C20.1740507,10.4970324 19.175803,9.32596983 17.954737,8.42991958 L18.6691315,7.71614485 C20.1406506,8.83051262 21.2994215,10.3051939 22,12 Z M16.1424647,10.2431889 C16.3725837,10.7833013 16.5,11.3771429 16.5,12 C16.5,14.48 14.48,16.5 12,16.5 C11.3771429,16.5 10.7833013,16.3725837 10.2431889,16.1424647 L11.024436,15.3614969 C11.3342462,15.4516488 11.6616178,15.5 12,15.5 C13.9288889,15.5 15.5,13.9288889 15.5,12 C15.5,11.6616178 15.4516488,11.3342462 15.3614969,11.024436 Z M12,6.5 C8.15360849,6.5 4.73551706,8.63675522 3.15777339,11.863607 L3.093,11.999 L3.15777339,12.136393 C4.03245683,13.9253235 5.47276555,15.3792162 7.23810116,16.3197311 L8.60618485,14.9509059 C7.91760811,14.1601291 7.5,13.127614 7.5,12 C7.5,9.52 9.52,7.5 12,7.5 C13.127614,7.5 14.1601291,7.91760811 14.9509059,8.60618485 L16.1681304,7.3888937 C14.9827532,6.85533762 13.6726343,6.54445962 12.3027469,6.50442017 L12,6.5 Z M12,8.5 C10.0711111,8.5 8.5,10.0711111 8.5,12 C8.5,12.8519259 8.80647577,13.6340603 9.31489177,14.2418677 L14.2418677,9.31489177 C13.6340603,8.80647577 12.8519259,8.5 12,8.5 Z"
						/>
					</g>
				</svg>
			);
			break;
		case LAYER_ICONS.VISIBLE:
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M3.5,0 C1.57111111,0 0,1.57111111 0,3.5 C0,5.42888889 1.57111111,7 3.5,7 C5.42888889,7 7,5.42888889 7,3.5 C7,1.57111111 5.42888889,0 3.5,0 Z"
							opacity=".5"
							transform="translate(8.5 8.5)"
						/>
						<path
							fill={color}
							d="M12,5.5 C16.5454545,5.5 20.4272727,8.19533333 22,12 C20.4272727,15.8046667 16.5454545,18.5 12,18.5 C7.45454545,18.5 3.57272727,15.8046667 2,12 C3.57272727,8.19533333 7.45454545,5.5 12,5.5 Z M12,6.5 C8.15360849,6.5 4.73551706,8.63675522 3.15777339,11.863607 L3.093,11.999 L3.15777339,12.136393 C4.69399749,15.2783276 7.97498342,17.3867843 11.6972531,17.4955798 L12,17.5 C15.8463915,17.5 19.2644829,15.3632448 20.8422266,12.136393 L20.906,11.999 L20.8422266,11.863607 C19.3060025,8.72167237 16.0250166,6.61321572 12.3027469,6.50442017 L12,6.5 Z M12,7.5 C9.52,7.5 7.5,9.52 7.5,12 C7.5,14.48 9.52,16.5 12,16.5 C14.48,16.5 16.5,14.48 16.5,12 C16.5,9.52 14.48,7.5 12,7.5 Z M12,8.5 C10.0711111,8.5 8.5,10.0711111 8.5,12 C8.5,13.9288889 10.0711111,15.5 12,15.5 C13.9288889,15.5 15.5,13.9288889 15.5,12 C15.5,10.0711111 13.9288889,8.5 12,8.5 Z"
						/>
					</g>
				</svg>
			);
			break;

		case 'bg-color':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(6.000000, 5.207000)" fill={color}>
							<path d="M6,0.793 C2.6862915,0.793 0,3.4792915 0,6.793 C0,10.1067085 2.6862915,12.793 6,12.793 C9.3137085,12.793 12,10.1067085 12,6.793 C12,3.4792915 9.3137085,0.793 6,0.793 Z" />
						</g>
						<path
							d="M12,5 C15.8659932,5 19,8.13400675 19,12 C19,15.8659932 15.8659932,19 12,19 C8.13400675,19 5,15.8659932 5,12 C5,8.13400675 8.13400675,5 12,5 Z M12,6 C8.6862915,6 6,8.6862915 6,12 C6,15.3137085 8.6862915,18 12,18 C15.3137085,18 18,15.3137085 18,12 C18,8.6862915 15.3137085,6 12,6 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'color-pick':
			icon = (
				<svg {...svgProps} viewBox="0 0 16 16">
					<path
						fill="currentColor"
						d="M14.513 1.625a1.686 1.686 0 00-2.378 0L10.212 3.55 9.025 2.36a.563.563 0 00-.793 0l-.79.793a.562.562 0 000 .793L12.194 8.7a.563.563 0 00.793 0l.793-.792a.563.563 0 000-.793l-1.19-1.19 1.923-1.922a1.686 1.686 0 000-2.377zM3.02 10.74l-.197 1.388-1.585 1.585 1.19 1.19 1.584-1.586L5.4 13.12l3.96-3.965-2.376-2.377L3.02 10.74z"
					/>
				</svg>
			);
			break;
		case 'bg-image':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(6.000000, 11.207000)" fill={color}>
							<path d="M2.729,0 L7.45902184,4.7296177 L8.83,3.359 L10.3728431,4.90134046 C9.2784138,6.06577994 7.72413257,6.793 6,6.793 C3.274231,6.793 0.972989442,4.97538193 0.242194849,2.48606531 L2.729,0 Z" />
						</g>
						<path
							d="M12,5 C15.8659932,5 19,8.13400675 19,12 C19,15.8659932 15.8659932,19 12,19 C8.13400675,19 5,15.8659932 5,12 C5,8.13400675 8.13400675,5 12,5 Z M8.729,11.207 L6.24219485,13.6930653 C6.97298944,16.1823819 9.274231,18 12,18 C13.7241326,18 15.2784138,17.2727799 16.3728431,16.1083405 L16.3728431,16.1083405 L14.83,14.566 L13.4590218,15.9366177 L8.729,11.207 Z M12,6 C8.6862915,6 6,8.6862915 6,12 C6,12.169025 6.00698919,12.3364177 6.02069432,12.5019046 L6.02069432,12.5019046 L8.72951092,9.79289322 L13.459,14.522 L14.8297428,13.1516832 L16.9988345,15.3195473 C17.6313946,14.3688912 18,13.2274918 18,12 C18,8.6862915 15.3137085,6 12,6 Z M14,8 C15.1045695,8 16,8.8954305 16,10 C16,11.1045695 15.1045695,12 14,12 C12.8954305,12 12,11.1045695 12,10 C12,8.8954305 12.8954305,8 14,8 Z M14,9 C13.4477153,9 13,9.44771525 13,10 C13,10.5522847 13.4477153,11 14,11 C14.5522847,11 15,10.5522847 15,10 C15,9.44771525 14.5522847,9 14,9 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'custom-tracker':
			icon = (
				<svg {...svgProps} viewBox="0 0 23 24">
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.7">
						<rect fill={color} x="2" y="15" width="4" height="8" />
						<rect fill={color} x="10" y="3" width="4" height="20" />
						<rect fill={color} x="17" y="10" width="4" height="13" />
					</g>
				</svg>
			);
			break;
		case 'script':
			icon = (
				<svg {...svgProps} viewBox="0 0 18 16">
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g transform="translate(-4.000000, -5.000000)">
							<path
								d="M20.9363478,6.06052174 C21.5449176,6.06052174 22.0382609,6.55386501 22.0382609,7.16243478 L22.0382609,19.2834783 C22.0382609,19.892048 21.5449176,20.3853913 20.9363478,20.3853913 L5.50956522,20.3853913 C4.90099545,20.3853913 4.40765217,19.892048 4.40765217,19.2834783 L4.40765217,7.16243478 C4.40765217,6.55386501 4.90099545,6.06052174 5.50956522,6.06052174 L20.9363478,6.06052174 Z M20.9363478,7.16243478 L5.50956522,7.16243478 L5.50956522,19.2834783 L20.9363478,19.2834783 L20.9363478,7.16243478 Z M14.8395806,10.4290186 L17.6335185,13.2229565 L14.8395806,16.0168944 L14.0604104,15.2377242 L16.0759573,13.2221774 L14.0604104,11.2081888 L14.8395806,10.4290186 Z M11.6092422,10.4290186 L12.3884124,11.2081888 L10.3728655,13.2221774 L12.3884124,15.2377242 L11.6092422,16.0168944 L8.81530435,13.2229565 L11.6092422,10.4290186 Z"
								fill={color}
							/>
						</g>
					</g>
				</svg>
			);
			break;
		case 'google-analytics':
			icon = (
				<svg {...svgProps} viewBox="0 0 23 23">
					<g
						stroke="none"
						strokeWidth="1"
						fill="none"
						fillRule="evenodd"
						strokeLinecap="round"
						strokeLinejoin="round"
					>
						<path
							d="M21.1536047,0 L16.9641387,0 C16.4703725,0.00322535409 15.9985276,0.204630798 15.6538975,0.55834463 C15.3092673,0.912058461 15.12132,1.38976924 15.1317415,1.88324841 L15.1317415,22.9867402 L21.1536047,22.9867402 C21.649527,22.9867402 22.1249657,22.7871266 22.4721113,22.4326961 C22.819257,22.0782655 23.0090012,21.5991212 22.9985796,21.1031334 L22.9985796,1.88360679 C23.0090012,1.387619 22.819257,0.908474735 22.4721113,0.554044158 C22.1249657,0.199613581 21.6498864,0 21.1536047,0 Z"
							fill="#F57C00"
						/>
						<path
							d="M7.25196627,9.05894451 L7.25196627,15.1197432 L1.80652301,15.1197432 C1.32706262,15.1198708 0.867375925,15.3103305 0.528983863,15.6490597 C0.190187897,15.9882706 0,16.4475365 0,16.9262999 L0,21.1034918 C0.0068279167,22.1026348 0.807490991,22.9147073 1.80652301,22.9358513 L15.1317415,22.9358513 L15.1317415,7.26488802 L9.07142639,7.26488802 C8.5920637,7.26163282 8.13109616,7.44873486 7.7902936,7.78492965 C7.44894706,8.12173764 7.25537086,8.57972961 7.25196627,9.05858614 L7.25196627,9.05894451 Z"
							fill="#FFC107"
						/>
						<path
							d="M21.1669011,22.8333567 L1.81946012,22.8333567 C0.826537285,22.8333567 0.019765022,22.0323938 0.0129370509,21.0393431 L0.0129370509,21.193085 C0.0129370509,21.6719725 0.203037121,22.1313846 0.541920968,22.4706836 C0.880313031,22.8094127 1.33999972,22.9998724 1.81946012,23 L21.1669011,23 C21.6631829,22.9967746 22.1368247,22.7939357 22.4818142,22.4369965 C22.8268036,22.0800573 23.0129542,21.5994796 22.9992984,21.1034918 L22.9992984,21.0009972 C22.9924705,22.0101747 22.1759954,22.8261893 21.1669011,22.8333567 Z"
							fill="#BF360C"
							opacity="0.2"
						/>
					</g>
				</svg>
			);
			break;
		case 'google-font':
			icon = (
				<svg {...svgProps} viewBox="0 0 509.58086729 397.8808683">
					<path d="m0 387.4 245.52-385.39 131.6 83.84-192.11 301.55z" fill="#fbbc04" />
					<path d="m240.33 0h151.13v387.4h-151.13z" fill="#1a73e8" />
					<circle cx="83.72" cy="81.35" fill="#ea4335" r="74.91" />
					<path
						d="m499.1 279.76a107.64 107.64 0 0 1 -107.64 107.64v-215.27a107.64 107.64 0 0 1 107.64 107.63z"
						fill="#34a853"
					/>
					<path d="m391.46 172.13v215.27a107.64 107.64 0 0 1 0-215.27z" fill="#0d652d" />
					<path
						d="m474.3 89.29a82.85 82.85 0 0 1 -82.84 82.84v-165.69a82.85 82.85 0 0 1 82.84 82.85z"
						fill="#1a73e8"
					/>
					<path d="m391.46 6.44v165.69a82.85 82.85 0 0 1 0-165.69z" fill="#174ea6" />
				</svg>
			);
			break;
		case 'custom-font':
			icon = (
				<svg {...svgProps} viewBox="0 0 24 30">
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g transform="translate(-318.000000, -558.000000)" fillRule="nonzero">
							<g transform="translate(288.000000, 544.000000)">
								<g transform="translate(26.000000, 13.000000)">
									<g transform="translate(4.173913, 1.333333)">
										<path
											d="M2.62801932,1.33333333 C1.17656425,1.33333333 0,2.47878788 0,3.87878788 L0,14.0606061 L0,19.1515152 L0,26.7878788 C0,28.1878788 1.17656425,29.3333333 2.62801932,29.3333333 L21.0241546,29.3333333 C22.4761353,29.3333333 23.6521739,28.1878788 23.6521739,26.7878788 L23.6521739,19.1515152 L23.6521739,14.0606061 L23.6521739,8.96969697 L15.7681159,1.33333333 L2.62801932,1.33333333 Z"
											fill="#95A5A6"
										/>
										<path
											d="M2.62801932,0 C1.17656425,0 0,1.14545455 0,2.54545455 L0,12.7272727 L0,17.8181818 L0,25.4545455 C0,26.8545455 1.17656425,28 2.62801932,28 L21.0241546,28 C22.4761353,28 23.6521739,26.8545455 23.6521739,25.4545455 L23.6521739,17.8181818 L23.6521739,12.7272727 L23.6521739,7.63636364 L15.7681159,0 L2.62801932,0 Z"
											fill="#BDC3C7"
										/>
										<g transform="translate(4.173913, 6.666667)" fill="#34495E">
											<path d="M10.7840261,11.0769231 L6.01793426,11.0769231 L5.06524442,12.2299595 L3.97553109,13.5125506 C3.76371947,13.7846154 3.60859355,14.0307692 3.51028547,14.2510121 C3.43457239,14.4323887 3.39678192,14.6008097 3.39678192,14.7692308 C3.39678192,14.9506073 3.49139024,15.1060729 3.68047472,15.2615385 C3.87722301,15.417004 4.19870628,15.5076923 4.64505667,15.5206478 L4.64505667,16 L0,16 L0,15.5206478 C0.408559914,15.4558704 0.934323141,15.3133603 1.25197451,15.1060729 C1.67559776,14.8080972 1.98822802,14.4582996 2.78262071,13.5384615 L13.0593825,0 L13.9129714,0 L13.9129714,12.8647773 C13.8905085,13.5125506 13.9499691,13.8882591 13.9499691,14.0178138 C13.9499691,14.5230769 14.053034,14.8987854 14.2565211,15.1190283 C14.4679364,15.3522267 14.8167715,15.4817814 15.3003838,15.5206478 L15.3043478,16 L8.34746572,16 L8.34746572,15.5336032 C9.00549559,15.4817814 9.68730968,15.417004 9.78508922,15.3651822 C9.99782579,15.2615385 10.4034787,15.0931174 10.576575,14.7692308 C10.7509925,14.4323887 11.0918996,13.7975709 11.1302186,12.9813765 L11.1302186,11.0769231 M11.1302186,9.84615385 L11.1302186,4.92307692 L6.9560893,9.84615385 L11.1302186,9.84615385" />
										</g>
										<path
											d="M23.6521739,8 L15.3043478,0 L15.3043478,5.33333333 C15.3043478,6.8 16.5495652,8 18.0869565,8 L23.6521739,8 Z"
											fill="#95A5A6"
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</svg>
			);
			break;
		// circle with x inside
		case 'remove-btn-icon':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M12,2 C6.47,2 2,6.47 2,12 C2,17.53 6.47,22 12,22 C17.53,22 22,17.53 22,12 C22,6.47 17.53,2 12,2 Z M17,15.59 L15.59,17 L12,13.41 L8.41,17 L7,15.59 L10.59,12 L7,8.41 L8.41,7 L12,10.59 L15.59,7 L17,8.41 L13.41,12 L17,15.59 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'embed-icon':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M19.0330435,5.50956522 C19.5862887,5.50956522 20.0347826,5.9580591 20.0347826,6.51130435 L20.0347826,17.5304348 C20.0347826,18.08368 19.5862887,18.5321739 19.0330435,18.5321739 L5.00869565,18.5321739 C4.45545041,18.5321739 4.00695652,18.08368 4.00695652,17.5304348 L4.00695652,6.51130435 C4.00695652,5.9580591 4.45545041,5.50956522 5.00869565,5.50956522 L19.0330435,5.50956522 Z M19.0330435,6.51130435 L5.00869565,6.51130435 L5.00869565,17.5304348 L19.0330435,17.5304348 L19.0330435,6.51130435 Z M13.4905278,9.48092604 L16.0304714,12.0208696 L13.4905278,14.5608131 L12.7821913,13.8524766 L14.6145066,12.0201612 L12.7821913,10.1892626 L13.4905278,9.48092604 Z M10.5538566,9.48092604 L11.2621931,10.1892626 L9.42987777,12.0201612 L11.2621931,13.8524766 L10.5538566,14.5608131 L8.01391304,12.0208696 L10.5538566,9.48092604 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'open-external':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<g opacity="0.5" transform="translate(5.000000, 4.957000)" fill={color}>
							<path d="M5,0.043 L5,1.043 L1,1.043 L1,13.043 L13,13.043 L13,9.043 L14,9.043 L14,13.043 C14,13.5952847 13.5522847,14.043 13,14.043 L1,14.043 C0.44771525,14.043 2.27373675e-12,13.5952847 2.27373675e-12,13.043 L2.27373675e-12,1.043 C2.27373675e-12,0.49071525 0.44771525,0.043 1,0.043 L5,0.043 Z" />
						</g>
						<path
							d="M19,5 L19,12 L17.4997962,12 L17.4997962,7.536 L10.8054564,14.231728 L9.74479618,13.1710678 L16.4147962,6.5 L11.9997962,6.5 L12,5 L19,5 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;
		case 'open-external-alt':
			icon = (
				<svg {...svgProps}>
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							fill={color}
							d="M16,7 L16,14 L14.4997962,14 L14.4997962,9.536 L6.80545635,17.231728 L5.74479618,16.1710678 L13.4147962,8.5 L8.99979618,8.5 L9,7 L16,7 Z"
						/>
					</g>
				</svg>
			);
			break;
		case 'copy-text':
			icon = (
				<svg {...svgProps} viewBox="0 0 16 16">
					<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
						<path
							d="M12,2.66666667 L4,2.66666667 C3.26666667,2.66666667 2.66666667,3.26666667 2.66666667,4 L2.66666667,12 C2.66666667,12.7333333 3.26666667,13.3333333 4,13.3333333 L12,13.3333333 C12.7333333,13.3333333 13.3333333,12.7333333 13.3333333,12 L13.3333333,4 C13.3333333,3.26666667 12.7333333,2.66666667 12,2.66666667 Z M12,2.66666667 C12.7363797,2.66666667 13.3333333,3.26362033 13.3333333,4 L13.3333333,12 C13.3333333,12.7363797 12.7363797,13.3333333 12,13.3333333 L4,13.3333333 C3.26362033,13.3333333 2.66666667,12.7363797 2.66666667,12 L2.66666667,10 L3.99966667,9.99966667 L4,4 L9.99966667,3.99966667 L10,2.66666667 L12,2.66666667 Z"
							fill={color}
						/>
						<path
							d="M12,5.33333333 L6.66666667,5.33333333 C5.93333333,5.33333333 5.33333333,5.93333333 5.33333333,6.66666667 L5.33333333,12 C5.33333333,12.7333333 5.93333333,13.3333333 6.66666667,13.3333333 L12,13.3333333 C12.7333333,13.3333333 13.3333333,12.7333333 13.3333333,12 L13.3333333,6.66666667 C13.3333333,5.93333333 12.7333333,5.33333333 12,5.33333333 Z M12,12 L6.66666667,12 L6.66666667,6.66666667 L12,6.66666667 L12,12 Z"
							fill={color}
						/>
					</g>
				</svg>
			);
			break;

		default:
			break;
	}

	return icon ? (
		<i className={`${css.icon} ${className}`} {...iconProps}>
			{icon}
		</i>
	) : null;
};

/*
const types = [
	'sc-arrow-updown',
	'sc-loop',
	'sc-symbol-add',
	'sc-circle-check',
	'sync-progress',
	'sync-updated',
	'arrow',
	'sc-arrow-thin',
	'close',
	'drag-handle',
	'keyboard-return',
	'more',
	'search',
	'tune',
	'swap-horizontal',
	'undo',
	'redo',
	'done-all',
	'edit',
	'edit-empty',
	'info',
	'chevron-left',
	'chevron-right',
	'chevron-up',
	'chevron-down',
	'remove',
	'remove-circle',
	'sync-problem',
	'sync-disabled',
	'sc-dropdown',
	'sc-menu',
	'sc-alert',
	'sc-option-key',
	'sc-override',
	'sc-plus',
	'sc-full-hd',
	'sc-computer',
	'sc-computer-default',
	'sc-tablet',
	'sc-phone-iphone',
	'sc-full-hd-no-paddings',
	'sc-computer-no-paddings',
	'sc-tablet-no-paddings',
	'sc-phone-iphone-no-paddings',
	'sc-layers',
	'sc-add-stroke',
	'sc-check',
	'sc-calendar',
	'sc-standalone',
	'sc-embed',
	'sc-publish',
	'sc-bind',
	'sc-unbind',
	...new Set(Object.values(PROP_FIELD_ICONS)).values(),
	...new Set(Object.values(LAYER_ICONS)).values(),
	'mail',
	'bg-color',
	'color-pick',
	'bg-image',
	'custom-tracker',
	'google-analytics',
	'google-font',
	'custom-font',
	'remove-btn-icon',
	'embed-icon',
	'open-external',
	'open-external-alt',
	'copy-text',
];

const size = 24;

export const IconsPreview = () => (
	<div
		style={{
			background: 'slategray',
			display: 'grid',
			gridTemplateColumns: `repeat(12, ${size}px)`,
			alignContent: 'center',
			justifyContent: 'center',
			height: '100vh',
			gridGap: 18,
		}}
	>
		{Object.values(types).map(type => (
			<Icon
				key={`icon-preview-${type}`}
				width={size}
				height={size}
				type={type as Props['type']}
				// @ts-ignore
				title={type}
				style={{ overflow: 'hidden' }}
			/>
		))}
	</div>
);
*/

export { Icon, LAYER_ICONS };
